define(["react","prop-types","mobx-state-tree","jquery","@ba/ba-ui-carbon-toolkit","underscore","@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons","mobx-react","polyglot","gemini/lib/@waca/dashboard-common/dist/core/APIFactory","react-dom","classnames","gemini/lib/@waca/baglass/js/baglass/utils/Utils"], function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_25__, __WEBPACK_EXTERNAL_MODULE_56__, __WEBPACK_EXTERNAL_MODULE_58__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 24);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _VisSlotEditorResources = __webpack_require__(12);

var _VisSlotEditorResources2 = _interopRequireDefault(_VisSlotEditorResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Polyglot = __webpack_require__(13);

var StringResources = function () {
	function StringResources() {
		_classCallCheck(this, StringResources);

		/**
   * Module which provides simple access to string resources.
   */
		this.polyglot = new Polyglot({
			phrases: _VisSlotEditorResources2.default
		});
	}

	/**
  * Get the string resource for the given key and interpolation options
  *
  * @param key						The  key of the string to return
  * @param interpolationOptions		Optional interpolation options (see poly.t documentation for details)
  * @returns							The string to display
  */


	_createClass(StringResources, [{
		key: 'get',
		value: function get(key, interpolationOptions) {
			return this.polyglot.t(key, interpolationOptions);
		}
	}]);

	return StringResources;
}();

exports.default = new StringResources();

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Gets the number of filter items
 * @param {object} localFilter the filter applied.
 * @return the number of filter items applied. If filter number is not applicable, return null
 */
var getNumberOfFilterItems = exports.getNumberOfFilterItems = function getNumberOfFilterItems(localFilter) {
	if (localFilter) {
		if (localFilter.operator === 'in' || localFilter.operator === 'notin' || localFilter.operator === 'isnull') {
			return localFilter.values.length;
		}
	}
	return null;
};

// Scrollable drag constants
var SCROLL_DRAG_DISTANCE = 20;
var handleScroll = exports.handleScroll = function handleScroll(e, scrollableContainer, onScrollCallback) {
	var boundingRect = scrollableContainer.getBoundingClientRect();
	var rect = {
		top: boundingRect.top,
		bottom: boundingRect.bottom
	};
	if (e.type === 'touchmove') {
		var coords = e.touches[0];
		if (coords) {
			e.clientX = coords.clientX;
			e.clientY = coords.clientY;
		}
	}
	if (!e.clientX || !e.clientY) {
		return;
	}
	var position = {
		x: e.clientX,
		y: e.clientY
	};
	var distanceBottom = rect.bottom - position.y;
	var distanceTop = position.y - rect.top;
	var isScrollingBottom = distanceBottom > 0 && distanceBottom < SCROLL_DRAG_DISTANCE;
	var isScrollingTop = distanceTop > 0 && distanceTop < SCROLL_DRAG_DISTANCE;
	var distanceY = 0;
	if (isScrollingTop && isScrollingBottom) {
		isScrollingTop = distanceTop > distanceBottom;
		isScrollingBottom = !isScrollingTop;
	}
	if (isScrollingBottom) {
		distanceY = SCROLL_DRAG_DISTANCE - distanceBottom;
	} else if (isScrollingTop) {
		distanceY = distanceTop - SCROLL_DRAG_DISTANCE;
	}
	var newScrollTop = scrollableContainer.scrollTop + distanceY;
	if (newScrollTop <= 0) {
		newScrollTop = 0;
	} else {
		var maxScrollTop = scrollableContainer.scrollHeight - scrollableContainer.clientHeight;
		if (newScrollTop > maxScrollTop) {
			newScrollTop = maxScrollTop;
		}
	}
	if (scrollableContainer.scrollTop !== newScrollTop) {
		scrollableContainer.scrollTop = newScrollTop;
		if (onScrollCallback) {
			onScrollCallback();
		}
	}
};

/** this function returns datasource id that will be used in type in dropdown
 * it exercises following logic: 
 * 1. if there is active datasource id, use it
 * 2. else, use first datasource id in the list of datasources
 */
var getDataSourceIdTypeIn = exports.getDataSourceIdTypeIn = function getDataSourceIdTypeIn(dashboardApi) {
	var sourceId = dashboardApi.getActiveDataSourceId();
	if (!sourceId) {
		var dataSourceFeature = dashboardApi.getFeature('DataSources');
		if (dataSourceFeature.getDataSourceList().length > 0) {
			sourceId = dataSourceFeature.getDataSourceList()[0].getId();
		}
	}
	return sourceId;
};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(33);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

var amdi18n={"__root":{"localFilters":"Local filters","slotEditorMsg1":"Required field","slotEditorMsg2":"Drag and drop data to the fields above to build and filter the visualization.","missingColumn":"Missing: %{columnLabel}","placeholderDropzone":"Click or drag data here","slotEditor_emptyState_no_visualization_selected_title":"No visualization selected","slotEditor_emptyState_no_visualization_selected_description":"Select a visualization to manage the field settings.","slotEditor_emptyState_widget_not_support_slot_selected_title":"The widget selected does not use fields","slotEditor_emptyState_widget_not_support_slot_selected_description":"Select a visualization to manage the field settings.","slotEditor_emptyState_multiple_visualizations_selected_title":"Multiple widgets selected","slotEditor_emptyState_multiple_visualizations_selected_description":"Select a visualization to manage the field settings.","slotEditor_emptyState_visualization_has_error_title":"The visualization cannot be displayed","slotEditor_slotItem_tooltip":"Source:","slotEditor_emptyState_vis_not_created_title":"No visualization created","slotEditor_emptyState_vis_not_created_description":"Create a visualization to manage the field settings.","slotEditor":"Fields","slotEditorCoachMarkTitle":"Access fields","slotEditorCoachMarkContents":"Add columns to the fields to build and modify visualizations.","toolbarDeleteFilterActionText":"Remove filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Filter bins","coachMarkTitleSpiralTarget":"Edit scope","coachMarkContentSpiralTarget":"This is where you can access and modify the driver selection for your target.","overlayDropZonePlaceHolderText":"Drag data here"},"__cs":{"localFilters":"Lokální filtry","slotEditorMsg1":"Povinné pole","slotEditorMsg2":"Přetáhněte data do polí nahoře, aby se sestavila a filtrovala vizualizace.","missingColumn":"Chybí: %{columnLabel}","placeholderDropzone":"Klepněte nebo přetáhněte data sem","slotEditor_emptyState_no_visualization_selected_title":"Není vybrána žádná vizualizace","slotEditor_emptyState_no_visualization_selected_description":"Vyberte vizualizaci pro správu nastavení polí.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Vybraný modul widget nepoužívá pole","slotEditor_emptyState_widget_not_support_slot_selected_description":"Vyberte vizualizaci pro správu nastavení polí.","slotEditor_emptyState_multiple_visualizations_selected_title":"Vícenásobný výběr modulů widget","slotEditor_emptyState_multiple_visualizations_selected_description":"Vyberte vizualizaci pro správu nastavení polí.","slotEditor_emptyState_visualization_has_error_title":"Vizualizaci nelze zobrazit","slotEditor_slotItem_tooltip":"Zdroj:","slotEditor_emptyState_vis_not_created_title":"Nebyla vytvořena žádná vizualizace","slotEditor_emptyState_vis_not_created_description":"Vytvořte vizualizaci pro správu nastavení polí.","slotEditor":"Pole","slotEditorCoachMarkTitle":"Přístupová pole","slotEditorCoachMarkContents":"Přidejte k polím sloupce, aby bylo možné sestavovat a upravovat vizualizace.","toolbarDeleteFilterActionText":"Odebrat filtr","toolbarActionFilter":"Filtr","filterAutobinActionText":"Filtrovat přihrádky","coachMarkTitleSpiralTarget":"Upravit rozsah","coachMarkContentSpiralTarget":"Zde je k dispozici přístup k výběru drivery pro cíl a možnost jeho úprav.","overlayDropZonePlaceHolderText":"Přetáhněte data sem"},"__da":{"localFilters":"Lokale filtre","slotEditorMsg1":"Påkrævet felt","slotEditorMsg2":"Træk og placér data til felterne ovenfor for at bygge og filtrere visualiseringen.","missingColumn":"Mangler: %{columnLabel}","placeholderDropzone":"Klik og træk data her","slotEditor_emptyState_no_visualization_selected_title":"Der er ikke valgt nogen visualisering","slotEditor_emptyState_no_visualization_selected_description":"Vælg en visualisering for at administrere feltindstillingerne.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Den valgte widget anvender ikke felter","slotEditor_emptyState_widget_not_support_slot_selected_description":"Vælg en visualisering for at administrere feltindstillingerne.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flere widgetter er valgt","slotEditor_emptyState_multiple_visualizations_selected_description":"Vælg en visualisering for at administrere feltindstillingerne.","slotEditor_emptyState_visualization_has_error_title":"Visualiseringen kan ikke vises","slotEditor_slotItem_tooltip":"Kilde:","slotEditor_emptyState_vis_not_created_title":"Ingen visualisering er oprettet","slotEditor_emptyState_vis_not_created_description":"Opret en visualisering for at administrere feltindstillingerne.","slotEditor":"Felter","slotEditorCoachMarkTitle":"Anvend felter","slotEditorCoachMarkContents":"Tilføj kolonner til felterne for at bygge og ændre visualiseringer.","toolbarDeleteFilterActionText":"Fjern filter","toolbarActionFilter":"Filtrér","filterAutobinActionText":"Filtrér områder (bins)","coachMarkTitleSpiralTarget":"Redigér omfang","coachMarkContentSpiralTarget":"Her kan du få adgang til og ændre styreprogramvalget for dit mål.","overlayDropZonePlaceHolderText":"Træk data her"},"__de":{"localFilters":"Lokale Filter","slotEditorMsg1":"Erforderliches Feld","slotEditorMsg2":"Daten in die Felder oben ziehen und ablegen, um die Visualisierung zu erstellen und zu filtern.","missingColumn":"Nicht vorhanden: %{columnLabel}","placeholderDropzone":"Klicken oder Daten hierher ziehen","slotEditor_emptyState_no_visualization_selected_title":"Keine Visualisierung ausgewählt","slotEditor_emptyState_no_visualization_selected_description":"Zum Verwalten der Feldeinstellungen eine Visualisierung auswählen.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Das ausgewählte Widget verwendet keine Felder.","slotEditor_emptyState_widget_not_support_slot_selected_description":"Zum Verwalten der Feldeinstellungen eine Visualisierung auswählen.","slotEditor_emptyState_multiple_visualizations_selected_title":"Mehrere Widgets ausgewählt","slotEditor_emptyState_multiple_visualizations_selected_description":"Zum Verwalten der Feldeinstellungen eine Visualisierung auswählen.","slotEditor_emptyState_visualization_has_error_title":"Die Visualisierung kann nicht angezeigt werden.","slotEditor_slotItem_tooltip":"Quelle:","slotEditor_emptyState_vis_not_created_title":"Keine Visualisierung erstellt","slotEditor_emptyState_vis_not_created_description":"Zum Verwalten der Feldeinstellungen eine Visualisierung erstellen.","slotEditor":"Felder","slotEditorCoachMarkTitle":"Felder aufrufen","slotEditorCoachMarkContents":"Spalten zu den Feldern hinzufügen, um Visualisierungen zu erstellen und zu ändern.","toolbarDeleteFilterActionText":"Filter entfernen","toolbarActionFilter":"Filtern","filterAutobinActionText":"Bins filtern","coachMarkTitleSpiralTarget":"Bereich bearbeiten","coachMarkContentSpiralTarget":"Hier können Sie auf die Auswahl der Einflussfaktoren für das Ziel zugreifen und gegebenenfalls Änderungen vornehmen.","overlayDropZonePlaceHolderText":"Daten hierher ziehen"},"__es":{"localFilters":"Filtros locales","slotEditorMsg1":"Campo necesario","slotEditorMsg2":"Arrastre y suelte los datos en los campos para crear y filtrar la visualización.","missingColumn":"Falta: %{columnLabel}","placeholderDropzone":"Pulse o arrastre los datos aquí","slotEditor_emptyState_no_visualization_selected_title":"No se ha seleccionado ninguna visualización","slotEditor_emptyState_no_visualization_selected_description":"Seleccione una visualización para gestionar los valores del campo.","slotEditor_emptyState_widget_not_support_slot_selected_title":"El widget seleccionado no utiliza campos","slotEditor_emptyState_widget_not_support_slot_selected_description":"Seleccione una visualización para gestionar los valores del campo.","slotEditor_emptyState_multiple_visualizations_selected_title":"Varios widgets seleccionados","slotEditor_emptyState_multiple_visualizations_selected_description":"Seleccione una visualización para gestionar los valores del campo.","slotEditor_emptyState_visualization_has_error_title":"No se puede mostrar la visualización","slotEditor_slotItem_tooltip":"Origen:","slotEditor_emptyState_vis_not_created_title":"No se ha creado ninguna visualización","slotEditor_emptyState_vis_not_created_description":"Cree una visualización para editar las propiedades del campo.","slotEditor":"Campos","slotEditorCoachMarkTitle":"Campos de acceso","slotEditorCoachMarkContents":"Añada columnas a los campos para crear y modificar las visualizaciones.","toolbarDeleteFilterActionText":"Eliminar filtro","toolbarActionFilter":"Filtro","filterAutobinActionText":"Filtrar cubetas","coachMarkTitleSpiralTarget":"Editar ámbito","coachMarkContentSpiralTarget":"Aquí puede acceder y modificar la selección de controlador de su destino.","overlayDropZonePlaceHolderText":"Arrastre los datos aquí"},"__fi":{"localFilters":"Paikalliset suodattimet","slotEditorMsg1":"Pakollinen kenttä","slotEditorMsg2":"Voit muodostaa visualisoinnin ja suodattaa sen vetämällä ja pudottamalla tiedot yllä oleviin kenttiin.","missingColumn":"Puuttuva: %{columnLabel}","placeholderDropzone":"Napsauta tätä, tai vedä tiedot tähän","slotEditor_emptyState_no_visualization_selected_title":"Visualisointia ei ole valittu","slotEditor_emptyState_no_visualization_selected_description":"Valitse visualisointi kentän asetusten hallintaa varten.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Valittu pienoisohjelma ei käytä kenttiä","slotEditor_emptyState_widget_not_support_slot_selected_description":"Valitse visualisointi kentän asetusten hallintaa varten.","slotEditor_emptyState_multiple_visualizations_selected_title":"Useita pienoisohjelmia valittu","slotEditor_emptyState_multiple_visualizations_selected_description":"Valitse visualisointi kentän asetusten hallintaa varten.","slotEditor_emptyState_visualization_has_error_title":"Visualisointia ei voi näyttää","slotEditor_slotItem_tooltip":"Lähde:","slotEditor_emptyState_vis_not_created_title":"Visualisointia ei ole luotu","slotEditor_emptyState_vis_not_created_description":"Luo visualisointi kentän asetusten hallintaa varten.","slotEditor":"Kentät","slotEditorCoachMarkTitle":"Kenttien käyttö","slotEditorCoachMarkContents":"Lisää kenttiin sarakkeita visualisointien muodostusta ja muuttamista varten.","toolbarDeleteFilterActionText":"Poista suodatin","toolbarActionFilter":"Suodatin","filterAutobinActionText":"Suodata numeroryhmät","coachMarkTitleSpiralTarget":"Muokkaa aluetta","coachMarkContentSpiralTarget":"Tässä voit käyttää ja muokata vaikuttimien valintaa kohdetta varten.","overlayDropZonePlaceHolderText":"Vedä tiedot tähän"},"__fr":{"localFilters":"Filtres locaux","slotEditorMsg1":"Zone requise","slotEditorMsg2":"Glissez-déposez des données sur les zones ci-dessus pour générer et filtrer la visualisation.","missingColumn":"Manquant : %{columnLabel}","placeholderDropzone":"Cliquez ou faites glisser les données ici","slotEditor_emptyState_no_visualization_selected_title":"Aucune visualisation sélectionnée","slotEditor_emptyState_no_visualization_selected_description":"Sélectionnez une visualisation pour gérer les paramètres de zone.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Le widget sélectionné n'utilise pas de zones","slotEditor_emptyState_widget_not_support_slot_selected_description":"Sélectionnez une visualisation pour gérer les paramètres de zone.","slotEditor_emptyState_multiple_visualizations_selected_title":"Plusieurs widgets sélectionnés","slotEditor_emptyState_multiple_visualizations_selected_description":"Sélectionnez une visualisation pour gérer les paramètres de zone.","slotEditor_emptyState_visualization_has_error_title":"Impossible d'afficher la visualisation","slotEditor_slotItem_tooltip":"Source :","slotEditor_emptyState_vis_not_created_title":"Aucune visualisation créée","slotEditor_emptyState_vis_not_created_description":"Créez une visualisation pour gérer les paramètres de zone.","slotEditor":"Zones","slotEditorCoachMarkTitle":"Accéder aux zones","slotEditorCoachMarkContents":"Ajoutez des colonnes aux zones pour générer et modifier les visualisations.","toolbarDeleteFilterActionText":"Retirer le filtre","toolbarActionFilter":"Filtre","filterAutobinActionText":"Filtrer les casiers","coachMarkTitleSpiralTarget":"Editer la portée","coachMarkContentSpiralTarget":"Vous pouvez accéder ici au pilote sélectionné pour votre cible et le modifier.","overlayDropZonePlaceHolderText":"Faites glisser les données ici"},"__hr":{"localFilters":"Lokalni filteri","slotEditorMsg1":"Obavezno polje","slotEditorMsg2":"Povucite podatke i ispustite ih na polja iznad da biste izgradili i filtrirali vizualizaciju.","missingColumn":"Nedostaje: %{columnLabel}","placeholderDropzone":"Kliknite ili povucite podatke ovdje","slotEditor_emptyState_no_visualization_selected_title":"Nema izabranih vizualizacija","slotEditor_emptyState_no_visualization_selected_description":"Izaberite vizualizaciju za upravljanje postavkama polja.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Izabrani grafički element ne koristi polja","slotEditor_emptyState_widget_not_support_slot_selected_description":"Izaberite vizualizaciju za upravljanje postavkama polja.","slotEditor_emptyState_multiple_visualizations_selected_title":"Izabrano je više grafičkih elemenata","slotEditor_emptyState_multiple_visualizations_selected_description":"Izaberite vizualizaciju za upravljanje postavkama polja.","slotEditor_emptyState_visualization_has_error_title":"Vizualizacija se ne može prikazati","slotEditor_slotItem_tooltip":"Izvor:","slotEditor_emptyState_vis_not_created_title":"Nije kreirana vizualizacija","slotEditor_emptyState_vis_not_created_description":"Kreirajte vizualizaciju za upravljanje postavkama polja.","slotEditor":"Polja","slotEditorCoachMarkTitle":"Pristup poljima","slotEditorCoachMarkContents":"Poljima dodajte stupce da izgradite i promijenite vizualizacije.","toolbarDeleteFilterActionText":"Ukloni filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Pregradci filtera","coachMarkTitleSpiralTarget":"Uređivanje opsega","coachMarkContentSpiralTarget":"Ovdje možete dohvatiti i promijeniti izbor pogonitelja za vaš cilj.","overlayDropZonePlaceHolderText":"Ovdje povucite podatke"},"__hu":{"localFilters":"Helyi szűrők","slotEditorMsg1":"Kötelező mező","slotEditorMsg2":"Húzza az adatokat a fenti mezőkre a megjelenítés összeállításához és szűréséhez.","missingColumn":"Hiányzik: %{columnLabel}","placeholderDropzone":"Kattintson vagy húzzon ide adatokat","slotEditor_emptyState_no_visualization_selected_title":"Nincs kijelölt megjelenítés","slotEditor_emptyState_no_visualization_selected_description":"Megjelenítés kiválasztása a mezőbeállítások kezeléséhez.","slotEditor_emptyState_widget_not_support_slot_selected_title":"A kiválasztott felületi elem nem használ mezőket","slotEditor_emptyState_widget_not_support_slot_selected_description":"Megjelenítés kiválasztása a mezőbeállítások kezeléséhez.","slotEditor_emptyState_multiple_visualizations_selected_title":"Több felületi elem van kiválasztva","slotEditor_emptyState_multiple_visualizations_selected_description":"Megjelenítés kiválasztása a mezőbeállítások kezeléséhez.","slotEditor_emptyState_visualization_has_error_title":"A megjelenítés nem jeleníthető meg","slotEditor_slotItem_tooltip":"Forrás:","slotEditor_emptyState_vis_not_created_title":"Nincs létrehozva megjelenítés","slotEditor_emptyState_vis_not_created_description":"Megjelenítés létrehozása a mezőbeállítások kezeléséhez.","slotEditor":"Mezők","slotEditorCoachMarkTitle":"Mezők elérése","slotEditorCoachMarkContents":"Oszlopok hozzáadása a mezőkhöz a megjelenítések összeállításához és módosításához.","toolbarDeleteFilterActionText":"Szűrő eltávolítása","toolbarActionFilter":"Szűrő","filterAutobinActionText":"Tároló szűrése","coachMarkTitleSpiralTarget":"Hatókör szerkesztése","coachMarkContentSpiralTarget":"Itt érheti el és módosíthatja a célhoz kijelölt tényezőket.","overlayDropZonePlaceHolderText":"Húzza ide az adatokat"},"__it":{"localFilters":"Filtri locali","slotEditorMsg1":"Campo richiesto","slotEditorMsg2":"Trascinare e rilasciare i dati nei campi sopra per costruire e filtrare la visualizzazione.","missingColumn":"Mancante: %{columnLabel}","placeholderDropzone":"Fare clic o trascinare i dati qui","slotEditor_emptyState_no_visualization_selected_title":"Nessuna visualizzazione selezionata","slotEditor_emptyState_no_visualization_selected_description":"Selezionare una visualizzazione per gestire le impostazioni del campo.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Il widget selezionato non utilizza campi","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selezionare una visualizzazione per gestire le impostazioni del campo.","slotEditor_emptyState_multiple_visualizations_selected_title":"Selezionati più elementi","slotEditor_emptyState_multiple_visualizations_selected_description":"Selezionare una visualizzazione per gestire le impostazioni del campo.","slotEditor_emptyState_visualization_has_error_title":"La visualizzazione non può essere visualizzata","slotEditor_slotItem_tooltip":"Sorgente:","slotEditor_emptyState_vis_not_created_title":"Nessuna visualizzazione creata","slotEditor_emptyState_vis_not_created_description":"Creare una visualizzazione per gestire le impostazioni del campo.","slotEditor":"Campi","slotEditorCoachMarkTitle":"Campi di accesso","slotEditorCoachMarkContents":"Aggiungi colonne ai campi per creare e modificare le visualizzazioni.","toolbarDeleteFilterActionText":"Rimuovi filtro","toolbarActionFilter":"Filtro","filterAutobinActionText":"Filtra bin","coachMarkTitleSpiralTarget":"Modifica ambito","coachMarkContentSpiralTarget":"Da qui è possibile accedere e modificare la selezione del driver per la propria destinazione.","overlayDropZonePlaceHolderText":"Trascinare qui i dati"},"__ja":{"localFilters":"ローカル・フィルター","slotEditorMsg1":"必須フィールド","slotEditorMsg2":"上のフィールドにデータをドラッグ・アンド・ドロップし、視覚化を作成してフィルターに掛けます。","missingColumn":"欠落しています: %{columnLabel}","placeholderDropzone":"データをクリックするかここにドラッグしてください","slotEditor_emptyState_no_visualization_selected_title":"視覚化が選択されていません","slotEditor_emptyState_no_visualization_selected_description":"フィールド設定を管理する視覚化を選択してください。","slotEditor_emptyState_widget_not_support_slot_selected_title":"選択したウィジェットではフィールドは使用されません","slotEditor_emptyState_widget_not_support_slot_selected_description":"フィールド設定を管理する視覚化を選択してください。","slotEditor_emptyState_multiple_visualizations_selected_title":"複数のウィジェットが選択されています","slotEditor_emptyState_multiple_visualizations_selected_description":"フィールド設定を管理する視覚化を選択してください。","slotEditor_emptyState_visualization_has_error_title":"視覚化を表示できません","slotEditor_slotItem_tooltip":"ソース:","slotEditor_emptyState_vis_not_created_title":"視覚化が作成されていません","slotEditor_emptyState_vis_not_created_description":"フィールド設定を管理する視覚化を作成してください。","slotEditor":"フィールド","slotEditorCoachMarkTitle":"アクセス・フィールド","slotEditorCoachMarkContents":"視覚化を作成および変更するための列をフィールドに追加します。","toolbarDeleteFilterActionText":"フィルターの削除","toolbarActionFilter":"フィルター","filterAutobinActionText":"ビンのフィルター","coachMarkTitleSpiralTarget":"範囲の編集","coachMarkContentSpiralTarget":"ここでターゲットのドライバー選択にアクセスして変更することができます。","overlayDropZonePlaceHolderText":"ここにデータをドラッグ"},"__kk":{"localFilters":"Жергілікті сүзгілер","slotEditorMsg1":"Қажетті өріс","slotEditorMsg2":"Көрнекілікті сүзгілеу және құру үшін өрістерге деректерді сүйреп апарып тастаңыз.","missingColumn":"Жоқ: %{columnLabel}","placeholderDropzone":"Деректерді мына жерге нұқыңыз немесе сүйреңіз","slotEditor_emptyState_no_visualization_selected_title":"Көрнекілендіру таңдалмаған","slotEditor_emptyState_no_visualization_selected_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру тандаңыз.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Таңдалған виджет өрістерды пайдаланбайды","slotEditor_emptyState_widget_not_support_slot_selected_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру тандаңыз.","slotEditor_emptyState_multiple_visualizations_selected_title":"Бірнеше виджеттер таңдалды","slotEditor_emptyState_multiple_visualizations_selected_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру тандаңыз.","slotEditor_emptyState_visualization_has_error_title":"Көрнекілендіруді көрсету мүмкін емес","slotEditor_slotItem_tooltip":"Бастапқы:","slotEditor_emptyState_vis_not_created_title":"Жасалған көрнекілендіру жоқ","slotEditor_emptyState_vis_not_created_description":"Өрістердің параметрлерін басқару үшін көрнекілендіру жасаңыз.","slotEditor":"Өрістер","slotEditorCoachMarkTitle":"Кіру өрістері","slotEditorCoachMarkContents":"Көрнекілендіру бейнелерді құру және өзгерту үшін өрістерге баған қосыңыз.","toolbarDeleteFilterActionText":"Сүзгіш жою","toolbarActionFilter":"Сүзгі","filterAutobinActionText":"Bin -дерді сүзгілеу","coachMarkTitleSpiralTarget":"Ауқымды өңдеу","coachMarkContentSpiralTarget":"Мұнда мақсатыңызға арналған драйвер таңдауына кіруге және оны өзгертуге болады.","overlayDropZonePlaceHolderText":"Деректерді осы жерге апарыңыз"},"__ko":{"localFilters":"로컬 필터","slotEditorMsg1":"필수 필드","slotEditorMsg2":"가상화를 빌드하고 필터링하려면 위의 필드에 데이터를 끌어서 놓습니다.","missingColumn":"누락: %{columnLabel}","placeholderDropzone":"데이터 클릭 또는 여기로 끌기","slotEditor_emptyState_no_visualization_selected_title":"선택된 시각화 없음","slotEditor_emptyState_no_visualization_selected_description":"시각화를 선택하여 필드 설정을 관리하십시오.","slotEditor_emptyState_widget_not_support_slot_selected_title":"선택한 위젯은 필드를 사용하지 않음","slotEditor_emptyState_widget_not_support_slot_selected_description":"시각화를 선택하여 필드 설정을 관리하십시오.","slotEditor_emptyState_multiple_visualizations_selected_title":"여러 위젯이 선택됨","slotEditor_emptyState_multiple_visualizations_selected_description":"시각화를 선택하여 필드 설정을 관리하십시오.","slotEditor_emptyState_visualization_has_error_title":"시각화를 표시할 수 없음","slotEditor_slotItem_tooltip":"소스:","slotEditor_emptyState_vis_not_created_title":"작성된 시각화 없음","slotEditor_emptyState_vis_not_created_description":"시각화를 작성하여 필드 설정을 관리하십시오.","slotEditor":"필드","slotEditorCoachMarkTitle":"필드 액세스","slotEditorCoachMarkContents":"필드에 열을 추가하여 시각화를 빌드하고 수정합니다.","toolbarDeleteFilterActionText":"필터 제거","toolbarActionFilter":"필터","filterAutobinActionText":"구간 필터","coachMarkTitleSpiralTarget":"범위 편집","coachMarkContentSpiralTarget":"대상에 대한 드라이버 선택에 액세스하고 수정할 수 있는 위치입니다.","overlayDropZonePlaceHolderText":"여기로 데이터 끌기"},"__nb":{"localFilters":"Lokale filtre","slotEditorMsg1":"Obligatorisk felt","slotEditorMsg2":"Dra og slipp data i feltene ovenfor for å bygge og filtrere visualiseringen.","missingColumn":"Mangler: %{columnLabel}","placeholderDropzone":"Klikk eller dra data hit","slotEditor_emptyState_no_visualization_selected_title":"Ingen visualisering valgt","slotEditor_emptyState_no_visualization_selected_description":"Velg en visualisering for å administrere feltinnstillingene.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Den valgte widgeten bruker ikke felt","slotEditor_emptyState_widget_not_support_slot_selected_description":"Velg en visualisering for å administrere feltinnstillingene.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flere widgeter valgt","slotEditor_emptyState_multiple_visualizations_selected_description":"Velg en visualisering for å administrere feltinnstillingene.","slotEditor_emptyState_visualization_has_error_title":"Visualiseringen kan ikke vises","slotEditor_slotItem_tooltip":"Kilde:","slotEditor_emptyState_vis_not_created_title":"Ingen visualisering opprettet","slotEditor_emptyState_vis_not_created_description":"Opprett en visualisering for å administrere feltinnstillingene.","slotEditor":"Felt","slotEditorCoachMarkTitle":"Valgbare felt","slotEditorCoachMarkContents":"Legg til kolonner for feltene for å bygge og endre visualiseringer.","toolbarDeleteFilterActionText":"Fjern filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Filtrer binger","coachMarkTitleSpiralTarget":"Rediger omfang","coachMarkContentSpiralTarget":"Her får du tilgang til og kan endre drivervalget for målet ditt.","overlayDropZonePlaceHolderText":"Dra data hit"},"__nl":{"localFilters":"Lokale filters","slotEditorMsg1":"Verplicht veld","slotEditorMsg2":"Sleep gegevens naar de bovenstaande velden om de visualisatie te bouwen en te filteren.","missingColumn":"Ontbrekend: %{columnLabel}","placeholderDropzone":"Klik hier of versleep gegevens hiernaartoe","slotEditor_emptyState_no_visualization_selected_title":"Geen visualisatie geselecteerd","slotEditor_emptyState_no_visualization_selected_description":"Selecteer een visualisatie om de veldinstellingen te beheren.","slotEditor_emptyState_widget_not_support_slot_selected_title":"De geselecteerde widget gebruikt geen velden","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selecteer een visualisatie om de veldinstellingen te beheren.","slotEditor_emptyState_multiple_visualizations_selected_title":"Meerdere widgets geselecteerd","slotEditor_emptyState_multiple_visualizations_selected_description":"Selecteer een visualisatie om de veldinstellingen te beheren.","slotEditor_emptyState_visualization_has_error_title":"De visualisatie kan niet worden weergegeven","slotEditor_slotItem_tooltip":"Bron:","slotEditor_emptyState_vis_not_created_title":"Geen visualisatie gemaakt","slotEditor_emptyState_vis_not_created_description":"Maak een visualisatie om de veldinstellingen te beheren.","slotEditor":"Velden","slotEditorCoachMarkTitle":"Toegangsvelden","slotEditorCoachMarkContents":"Voeg kolommen aan de velden toe om visualisaties te bouwen en te wijzigen. ","toolbarDeleteFilterActionText":"Filter verwijderen","toolbarActionFilter":"Filteren","filterAutobinActionText":"Bins filteren","coachMarkTitleSpiralTarget":"Bereik bewerken","coachMarkContentSpiralTarget":"Dit is de plek waar u toegang hebt tot de driverselectie voor uw doel en waar u wijzigingen kunt aanbrengen.","overlayDropZonePlaceHolderText":"Sleep gegevens hiernaartoe"},"__no":{"localFilters":"Lokale filtre","slotEditorMsg1":"Obligatorisk felt","slotEditorMsg2":"Dra og slipp data i feltene ovenfor for å bygge og filtrere visualiseringen.","missingColumn":"Mangler: %{columnLabel}","placeholderDropzone":"Klikk eller dra data hit","slotEditor_emptyState_no_visualization_selected_title":"Ingen visualisering valgt","slotEditor_emptyState_no_visualization_selected_description":"Velg en visualisering for å administrere feltinnstillingene.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Den valgte widgeten bruker ikke felt","slotEditor_emptyState_widget_not_support_slot_selected_description":"Velg en visualisering for å administrere feltinnstillingene.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flere widgeter valgt","slotEditor_emptyState_multiple_visualizations_selected_description":"Velg en visualisering for å administrere feltinnstillingene.","slotEditor_emptyState_visualization_has_error_title":"Visualiseringen kan ikke vises","slotEditor_slotItem_tooltip":"Kilde:","slotEditor_emptyState_vis_not_created_title":"Ingen visualisering opprettet","slotEditor_emptyState_vis_not_created_description":"Opprett en visualisering for å administrere feltinnstillingene.","slotEditor":"Felt","slotEditorCoachMarkTitle":"Valgbare felt","slotEditorCoachMarkContents":"Legg til kolonner for feltene for å bygge og endre visualiseringer.","toolbarDeleteFilterActionText":"Fjern filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Filtrer binger","coachMarkTitleSpiralTarget":"Rediger omfang","coachMarkContentSpiralTarget":"Her får du tilgang til og kan endre drivervalget for målet ditt.","overlayDropZonePlaceHolderText":"Dra data hit"},"__pl":{"localFilters":"Filtry lokalne","slotEditorMsg1":"Pole wymagane","slotEditorMsg2":"Przeciągnij i upuść dane w powyższych polach, aby utworzyć i przefiltrować wizualizację.","missingColumn":"Brak: %{columnLabel}","placeholderDropzone":"Kliknij lub przeciągnij dane w to miejsce","slotEditor_emptyState_no_visualization_selected_title":"Nie wybrano wizualizacji","slotEditor_emptyState_no_visualization_selected_description":"Wybierz wizualizację, aby zarządzać ustawieniami pól.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Wybrany widget nie używa pól","slotEditor_emptyState_widget_not_support_slot_selected_description":"Wybierz wizualizację, aby zarządzać ustawieniami pól.","slotEditor_emptyState_multiple_visualizations_selected_title":"Wybrano więcej niż jeden widget","slotEditor_emptyState_multiple_visualizations_selected_description":"Wybierz wizualizację, aby zarządzać ustawieniami pól.","slotEditor_emptyState_visualization_has_error_title":"Nie można wyświetlić wizualizacji","slotEditor_slotItem_tooltip":"Źródło:","slotEditor_emptyState_vis_not_created_title":"Nie utworzono żadnej wizualizacji","slotEditor_emptyState_vis_not_created_description":"Utwórz wizualizację, aby zarządzać ustawieniami pól.","slotEditor":"Pola","slotEditorCoachMarkTitle":"Uzyskaj dostęp do pól","slotEditorCoachMarkContents":"Dodaj kolumny do pól, aby budować i modyfikować wizualizacje.","toolbarDeleteFilterActionText":"Usuń filtr","toolbarActionFilter":"Filtruj","filterAutobinActionText":"Filtruj kategorie","coachMarkTitleSpiralTarget":"Edytuj zakres","coachMarkContentSpiralTarget":"W tym miejscu można uzyskać dostęp do czynników dla zmiennej przewidywanej i zmodyfikować ich wybór.","overlayDropZonePlaceHolderText":"Przeciągnij dane w to miejsce"},"__pt":{"localFilters":"Filtros locais","slotEditorMsg1":"Campo requerido","slotEditorMsg2":"Arraste e solte dados para os campos acima para criar e filtrar a visualização.","missingColumn":"Ausente: %{columnLabel}","placeholderDropzone":"Clicar ou arrastar dados aqui","slotEditor_emptyState_no_visualization_selected_title":"Nenhuma visualização selecionada","slotEditor_emptyState_no_visualization_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_widget_not_support_slot_selected_title":"O widget selecionado não usa campos","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_multiple_visualizations_selected_title":"Vários widgets selecionados","slotEditor_emptyState_multiple_visualizations_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_visualization_has_error_title":"Não é possível exibir a visualização","slotEditor_slotItem_tooltip":"Origem:","slotEditor_emptyState_vis_not_created_title":"Nenhuma visualização criada","slotEditor_emptyState_vis_not_created_description":"Crie uma visualização para gerenciar as configurações de campo.","slotEditor":"Campos","slotEditorCoachMarkTitle":"Campos de acesso","slotEditorCoachMarkContents":"Inclua colunas nos campos para criar e modificar visualizações.","toolbarDeleteFilterActionText":"Remover filtro","toolbarActionFilter":"Filtrar","filterAutobinActionText":"Filtro de categorias","coachMarkTitleSpiralTarget":"Editar escopo","coachMarkContentSpiralTarget":"Este é o local onde é possível acessar e modificar a seleção do driver para seu destino.","overlayDropZonePlaceHolderText":"Arraste os dados para cá"},"__pt-br":{"localFilters":"Filtros locais","slotEditorMsg1":"Campo requerido","slotEditorMsg2":"Arraste e solte dados para os campos acima para criar e filtrar a visualização.","missingColumn":"Ausente: %{columnLabel}","placeholderDropzone":"Clicar ou arrastar dados aqui","slotEditor_emptyState_no_visualization_selected_title":"Nenhuma visualização selecionada","slotEditor_emptyState_no_visualization_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_widget_not_support_slot_selected_title":"O widget selecionado não usa campos","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_multiple_visualizations_selected_title":"Vários widgets selecionados","slotEditor_emptyState_multiple_visualizations_selected_description":"Selecione uma visualização para gerenciar as configurações de campo.","slotEditor_emptyState_visualization_has_error_title":"Não é possível exibir a visualização","slotEditor_slotItem_tooltip":"Origem:","slotEditor_emptyState_vis_not_created_title":"Nenhuma visualização criada","slotEditor_emptyState_vis_not_created_description":"Crie uma visualização para gerenciar as configurações de campo.","slotEditor":"Campos","slotEditorCoachMarkTitle":"Campos de acesso","slotEditorCoachMarkContents":"Inclua colunas nos campos para criar e modificar visualizações.","toolbarDeleteFilterActionText":"Remover filtro","toolbarActionFilter":"Filtrar","filterAutobinActionText":"Filtro de categorias","coachMarkTitleSpiralTarget":"Editar escopo","coachMarkContentSpiralTarget":"Este é o local onde é possível acessar e modificar a seleção do driver para seu destino.","overlayDropZonePlaceHolderText":"Arraste os dados para cá"},"__ro":{"localFilters":"Caracteristici locale filtru","slotEditorMsg1":"Câmp necesar","slotEditorMsg2":"Trageţi şi plasaţi datele în câmpurile de deasupra, pentru a construi şi filtra vizualizarea.","missingColumn":"Lipsă: %{columnLabel}","placeholderDropzone":"Faceţi clic sau trageţi date aici","slotEditor_emptyState_no_visualization_selected_title":"Nicio vizualizare selectată","slotEditor_emptyState_no_visualization_selected_description":"Selectaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Widget-ul selectat nu utilizează câmpuri.","slotEditor_emptyState_widget_not_support_slot_selected_description":"Selectaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor_emptyState_multiple_visualizations_selected_title":"Sunt selectate mai multe widget-uri","slotEditor_emptyState_multiple_visualizations_selected_description":"Selectaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor_emptyState_visualization_has_error_title":"Vizualizarea nu poate fi afişată","slotEditor_slotItem_tooltip":"Sursă:","slotEditor_emptyState_vis_not_created_title":"Nu a fost creată nicio vizualizare","slotEditor_emptyState_vis_not_created_description":"Creaţi o vizualizare pentru gestionarea setărilor de câmp.","slotEditor":"Câmpuri","slotEditorCoachMarkTitle":"Accesare câmpuri","slotEditorCoachMarkContents":"Adăugaţi coloane la câmpuri pentru a construi şi modifica vizualizările.","toolbarDeleteFilterActionText":"Înlăturare filtru","toolbarActionFilter":"Filtru","filterAutobinActionText":"Filtrare bin-uri","coachMarkTitleSpiralTarget":"Editare domeniu","coachMarkContentSpiralTarget":"Aici puteţi accesa şi modifica selecţia de driver-e pentru ţinta dumneavoastră.","overlayDropZonePlaceHolderText":"Trageţi date aici"},"__ru":{"localFilters":"Локальные фильтры","slotEditorMsg1":"Обязательное поле","slotEditorMsg2":"Перетащите данные на находящиеся выше поля, чтобы построить визуализацию и применить к ней фильтр.","missingColumn":"Отсутствует: %{columnLabel}","placeholderDropzone":"Щелкните здесь или перетащите сюда данные","slotEditor_emptyState_no_visualization_selected_title":"Визуализация не отобрана","slotEditor_emptyState_no_visualization_selected_description":"Выберите визуализацию для управления настройками полей.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Выбранный виджет не использует поля","slotEditor_emptyState_widget_not_support_slot_selected_description":"Выберите визуализацию для управления настройками полей.","slotEditor_emptyState_multiple_visualizations_selected_title":"Выбрано несколько виджетов","slotEditor_emptyState_multiple_visualizations_selected_description":"Выберите визуализацию для управления настройками полей.","slotEditor_emptyState_visualization_has_error_title":"Вывести визуализацию невозможно","slotEditor_slotItem_tooltip":"Источник:","slotEditor_emptyState_vis_not_created_title":"Визуализация не создана","slotEditor_emptyState_vis_not_created_description":"Создайте визуализацию для управления настройками полей.","slotEditor":"Поля","slotEditorCoachMarkTitle":"Доступ к полям","slotEditorCoachMarkContents":"Добавьте в поля столбцы для построения и изменения визуализаций.","toolbarDeleteFilterActionText":"Удалить фильтр","toolbarActionFilter":"Фильтр","filterAutobinActionText":"Применить фильтр к контейнерам","coachMarkTitleSpiralTarget":"Изменить область","coachMarkContentSpiralTarget":"Здесь можно получить доступ и изменить выбор драйвера для целевого объекта.","overlayDropZonePlaceHolderText":"Перетащите сюда данные"},"__sl":{"localFilters":"Lokalni filtri","slotEditorMsg1":"Obvezno polje","slotEditorMsg2":"Povlecite in spustite podatke v polja zgoraj, da zgradite in filtrirate vizualizacijo.","missingColumn":"Manjka: %{columnLabel}","placeholderDropzone":"Kliknite ali povlecite podatke sem","slotEditor_emptyState_no_visualization_selected_title":"Izbrana ni nobena vizualizacija","slotEditor_emptyState_no_visualization_selected_description":"Izberite vizualizacijo za upravljanje nastavitev polja.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Izbrani gradnik ne uporablja polj","slotEditor_emptyState_widget_not_support_slot_selected_description":"Izberite vizualizacijo za upravljanje nastavitev polja.","slotEditor_emptyState_multiple_visualizations_selected_title":"Izbranih je več gradnikov","slotEditor_emptyState_multiple_visualizations_selected_description":"Izberite vizualizacijo za upravljanje nastavitev polja.","slotEditor_emptyState_visualization_has_error_title":"Vizualizacije ni mogoče prikazati","slotEditor_slotItem_tooltip":"Izvor:","slotEditor_emptyState_vis_not_created_title":"Ustvarjena ni bila nobena vizualizacija","slotEditor_emptyState_vis_not_created_description":"Ustvarite vizualizacijo za upravljanje nastavitev polja.","slotEditor":"Polja","slotEditorCoachMarkTitle":"Dostop do polj","slotEditorCoachMarkContents":"V polja dodajte stolpce, da izdelate in spremenite vizualizacije.","toolbarDeleteFilterActionText":"Odstrani filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Predali filtra","coachMarkTitleSpiralTarget":"Urejanje območja","coachMarkContentSpiralTarget":"Tukaj lahko dostopate do izbora gonilnikov za svoj cilj in jih spreminjate.","overlayDropZonePlaceHolderText":"Podatke povlecite sem"},"__sv":{"localFilters":"Lokala filter","slotEditorMsg1":"Obligatoriskt fält","slotEditorMsg2":"Dra data till fälten ovan för att skapa och filtrera visualiseringen.","missingColumn":"Saknas: %{columnLabel}","placeholderDropzone":"Klicka eller dra data hit","slotEditor_emptyState_no_visualization_selected_title":"Ingen visualisering vald","slotEditor_emptyState_no_visualization_selected_description":"Välj en visualisering för att hantera fältinställningarna.","slotEditor_emptyState_widget_not_support_slot_selected_title":"Vald widget använder inte fält","slotEditor_emptyState_widget_not_support_slot_selected_description":"Välj en visualisering för att hantera fältinställningarna.","slotEditor_emptyState_multiple_visualizations_selected_title":"Flera widgetar har valts","slotEditor_emptyState_multiple_visualizations_selected_description":"Välj en visualisering för att hantera fältinställningarna.","slotEditor_emptyState_visualization_has_error_title":"Det går inte visa visualiseringen.","slotEditor_slotItem_tooltip":"Källa:","slotEditor_emptyState_vis_not_created_title":"Inga visualiseringar har skapats","slotEditor_emptyState_vis_not_created_description":"Skapa en visualisering för att hantera fältinställningarna.","slotEditor":"Fält","slotEditorCoachMarkTitle":"Åtkomstfält","slotEditorCoachMarkContents":"Lägg till kolumner i fälten för att bygga och ändra visualiseringar.","toolbarDeleteFilterActionText":"Ta bort filter","toolbarActionFilter":"Filter","filterAutobinActionText":"Filtrera bin","coachMarkTitleSpiralTarget":"Ändra omfattning","coachMarkContentSpiralTarget":"Här kan du komma åt och ändra valet av styrfunktioner för målet.","overlayDropZonePlaceHolderText":"Dra data hit"},"__th":{"localFilters":"ตัวกรองโลคัล","slotEditorMsg1":"ฟิลด์ที่จำเป็น","slotEditorMsg2":"ลากและปล่อยข้อมูลลงในฟิลด์ด้านบนเพื่อสร้างและกรองวิชวลไลเซชัน","missingColumn":"ไม่มี: %{columnLabel}","placeholderDropzone":"คลิกหรือลากข้อมูลที่นี่","slotEditor_emptyState_no_visualization_selected_title":"ไม่ได้เลือกวิชวลไลเซชัน","slotEditor_emptyState_no_visualization_selected_description":"เลือกวิชวลไลเซชันเพื่อจัดการการตั้งค่าฟิลด์","slotEditor_emptyState_widget_not_support_slot_selected_title":"วิดเจ็ตที่เลือกไม่ใช้ฟิลด์","slotEditor_emptyState_widget_not_support_slot_selected_description":"เลือกวิชวลไลเซชันเพื่อจัดการการตั้งค่าฟิลด์","slotEditor_emptyState_multiple_visualizations_selected_title":"เลือกหลายวิดเจ็ต","slotEditor_emptyState_multiple_visualizations_selected_description":"เลือกวิชวลไลเซชันเพื่อจัดการการตั้งค่าฟิลด์","slotEditor_emptyState_visualization_has_error_title":"ไม่สามารถแสดงวิชวลไลเซชัน","slotEditor_slotItem_tooltip":"ซอร์ส:","slotEditor_emptyState_vis_not_created_title":"ไม่มีการสร้างวิชวลไลเซชัน","slotEditor_emptyState_vis_not_created_description":"สร้างวิชวลไลเซชันเพื่อจัดการการตั้งค่าฟิลด์","slotEditor":"ฟิลด์","slotEditorCoachMarkTitle":"เข้าถึงฟิลด์","slotEditorCoachMarkContents":"เพิ่มคอลัมน์ลงในฟิลด์เพื่อสร้างและปรับเปลี่ยนวิชวลไลเซชัน","toolbarDeleteFilterActionText":"ลบตัวกรอง","toolbarActionFilter":"ตัวกรอง","filterAutobinActionText":"ถังกรอง","coachMarkTitleSpiralTarget":"แก้ไขขอบเขต","coachMarkContentSpiralTarget":"นี่เป็นตำแหน่งที่คุณสามารถเข้าถึงและปรับเปลี่ยนการเลือกไดรเวอร์สำหรับเป้าหมายของคุณ","overlayDropZonePlaceHolderText":"ลากข้อมูลที่นี่"},"__tr":{"localFilters":"Yerel süzgeçler","slotEditorMsg1":"Zorunlu alan","slotEditorMsg2":"Görselleştirmeyi oluşturmak ve süzgeçten geçirmek için, verileri yukarıdaki alanlara sürükleyip bırakın.","missingColumn":"Eksik: %{columnLabel}","placeholderDropzone":"Tıklatın veya verileri buraya sürükleyin","slotEditor_emptyState_no_visualization_selected_title":"Bir görselleştirme seçilmedi","slotEditor_emptyState_no_visualization_selected_description":"Alan ayarlarını yönetmek için bir görselleştirme seçin","slotEditor_emptyState_widget_not_support_slot_selected_title":"Seçilen pencere öğesi alanları kullanmıyor","slotEditor_emptyState_widget_not_support_slot_selected_description":"Alan ayarlarını yönetmek için bir görselleştirme seçin","slotEditor_emptyState_multiple_visualizations_selected_title":"Birden çok pencere öğesi seçildi","slotEditor_emptyState_multiple_visualizations_selected_description":"Alan ayarlarını yönetmek için bir görselleştirme seçin","slotEditor_emptyState_visualization_has_error_title":"Görselleştirme görüntülenemiyor","slotEditor_slotItem_tooltip":"Kaynak:","slotEditor_emptyState_vis_not_created_title":"Bir görselleştirme oluşturulmadı","slotEditor_emptyState_vis_not_created_description":"Alan ayarlarını yönetmek için bir görselleştirme yaratın.","slotEditor":"Alanlar","slotEditorCoachMarkTitle":"Erişim alanları","slotEditorCoachMarkContents":"Görselleştirme oluşturmak ve görselleştirmeleri değiştirmek için alanlara sütun ekleyin.","toolbarDeleteFilterActionText":"Süzgeci kaldır","toolbarActionFilter":"Süzgeç","filterAutobinActionText":"Süzgeç bölmeleri","coachMarkTitleSpiralTarget":"Kapsamı düzenle","coachMarkContentSpiralTarget":"Burası, hedefiniz için sürücü seçimine erişebileceğiniz ve sürücü seçimini değiştirebileceğiniz yerdir.","overlayDropZonePlaceHolderText":"Verileri buraya sürükleyin"},"__zh":{"localFilters":"本地过滤器","slotEditorMsg1":"必填字段","slotEditorMsg2":"将数据拖放到字段上方以构建并过滤可视化。","missingColumn":"缺少：%{columnLabel}","placeholderDropzone":"单击数据或将数据拖到此处","slotEditor_emptyState_no_visualization_selected_title":"未选择任何可视化","slotEditor_emptyState_no_visualization_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_widget_not_support_slot_selected_title":"所选窗口小部件不使用字段","slotEditor_emptyState_widget_not_support_slot_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_multiple_visualizations_selected_title":"已选择多个窗口小部件","slotEditor_emptyState_multiple_visualizations_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_visualization_has_error_title":"无法显示可视化","slotEditor_slotItem_tooltip":"源：","slotEditor_emptyState_vis_not_created_title":"未创建任何可视化","slotEditor_emptyState_vis_not_created_description":"创建可视化以管理字段设置。","slotEditor":"字段","slotEditorCoachMarkTitle":"访问字段","slotEditorCoachMarkContents":"向字段添加列以构建并修改可视化。","toolbarDeleteFilterActionText":"除去过滤器","toolbarActionFilter":"过滤器","filterAutobinActionText":"过滤分箱","coachMarkTitleSpiralTarget":"编辑作用域","coachMarkContentSpiralTarget":"您可以在此访问和修改目标的动因选择。","overlayDropZonePlaceHolderText":"将数据拖到此处"},"__zh-cn":{"localFilters":"本地过滤器","slotEditorMsg1":"必填字段","slotEditorMsg2":"将数据拖放到字段上方以构建并过滤可视化。","missingColumn":"缺少：%{columnLabel}","placeholderDropzone":"单击数据或将数据拖到此处","slotEditor_emptyState_no_visualization_selected_title":"未选择任何可视化","slotEditor_emptyState_no_visualization_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_widget_not_support_slot_selected_title":"所选窗口小部件不使用字段","slotEditor_emptyState_widget_not_support_slot_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_multiple_visualizations_selected_title":"已选择多个窗口小部件","slotEditor_emptyState_multiple_visualizations_selected_description":"选择可视化以管理字段设置。","slotEditor_emptyState_visualization_has_error_title":"无法显示可视化","slotEditor_slotItem_tooltip":"源：","slotEditor_emptyState_vis_not_created_title":"未创建任何可视化","slotEditor_emptyState_vis_not_created_description":"创建可视化以管理字段设置。","slotEditor":"字段","slotEditorCoachMarkTitle":"访问字段","slotEditorCoachMarkContents":"向字段添加列以构建并修改可视化。","toolbarDeleteFilterActionText":"除去过滤器","toolbarActionFilter":"过滤器","filterAutobinActionText":"过滤分箱","coachMarkTitleSpiralTarget":"编辑作用域","coachMarkContentSpiralTarget":"您可以在此访问和修改目标的动因选择。","overlayDropZonePlaceHolderText":"将数据拖到此处"},"__zh-tw":{"localFilters":"本端過濾器","slotEditorMsg1":"必要欄位","slotEditorMsg2":"將資料拖放至上方的欄位來建置及過濾視覺化。","missingColumn":"遺漏：%{columnLabel}","placeholderDropzone":"在這裡按一下或拖曳資料","slotEditor_emptyState_no_visualization_selected_title":"未選取任何視覺化","slotEditor_emptyState_no_visualization_selected_description":"選取視覺化以管理欄位設定。","slotEditor_emptyState_widget_not_support_slot_selected_title":"選取的小組件未使用欄位","slotEditor_emptyState_widget_not_support_slot_selected_description":"選取視覺化以管理欄位設定。","slotEditor_emptyState_multiple_visualizations_selected_title":"已選取多個小組件","slotEditor_emptyState_multiple_visualizations_selected_description":"選取視覺化以管理欄位設定。","slotEditor_emptyState_visualization_has_error_title":"無法顯示視覺化","slotEditor_slotItem_tooltip":"來源：","slotEditor_emptyState_vis_not_created_title":"未建立任何視覺化","slotEditor_emptyState_vis_not_created_description":"建立視覺化以管理欄位設定。","slotEditor":"欄位","slotEditorCoachMarkTitle":"存取欄位","slotEditorCoachMarkContents":"將直欄新增至欄位以建置並修改視覺化。","toolbarDeleteFilterActionText":"移除過濾器","toolbarActionFilter":"過濾","filterAutobinActionText":"過濾組","coachMarkTitleSpiralTarget":"編輯範圍","coachMarkContentSpiralTarget":"您可以在此處存取及修改目標動因選項。","overlayDropZonePlaceHolderText":"將資料拖曳到這裡"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_13__;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(32);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(9)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js??ref--1-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-4!./slotEditor.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js??ref--1-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-4!./slotEditor.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SLOT_ITEM_TOUCH_DRAG_DURATION = 600;

var DndSlotItemHandler = function () {
	/**
  * DndSlotItemHandler hides most of the drag and drop handling used by the glass DndManager
  * It handles drop of data from the metadata tree to a Slot Item (or Slot Heading)
  * It also handles Drag&Drop of slot to slot data.
  *
  * @param {Object} 	options
  * @param {DOMNode} options.domNode - DOM node to attach drag and drop to
  * @param {string} 	options.className - class name
  * @param {Function} options.slotDataItemHandler - the slotDataItemHandler.
  * @param {Boolean}	options.addAfter - true if this drop is after a slot
  * @param {Object} 	options.dndManager - the drag&drop manager.
  * @param {Function} [options.onDragEnter] - oprional function to be executed in addition to activateDropTarget when entering this target
  * @param {Function} [options.onDragLeave] - oprional function to be executed in addition to activateDropTarget when exiting this target
  * @param {Boolean} [options.isVisOverlay] - if set, this target is a visOverlay....rules are determined in VisDnDManager.
  */
	function DndSlotItemHandler(options) {
		_classCallCheck(this, DndSlotItemHandler);

		this.domNode = options.domNode;
		this.className = options.className;

		this.slotDataItemHandler = options.slotDataItemHandler;

		this.addAfter = options.addAfter;
		this.dndManager = options.dndManager;
		this.onDragEnter = options.onDragEnter; //custom drag enter handling (in addition to activateDropTarget)
		this.onDragLeave = options.onDragLeave; //custom drag enter handling (in addition to deactivateDropTarget)
		this.isVisOverlay = options.isVisOverlay;
		this.timer = null;

		// Register slot as a drop target
		if (this.dndManager) {
			this._setupDnD();
		}
	}

	_createClass(DndSlotItemHandler, [{
		key: '_setupDnD',
		value: function _setupDnD() {
			var _this = this;

			var onDrop = this.slotDataItemHandler && this.slotDataItemHandler.onDrop && this.slotDataItemHandler.onDrop.bind(this.slotDataItemHandler);

			//NOTE: registering a new dropTarget on a node derigisters the old one.
			this.dndManager.registerDropTarget({
				el: this.domNode,
				type: 'slot.item',
				info: function info(domNode, event) {
					return {
						//position info
						dragInfo: {
							position: {
								x: event.clientX,
								y: event.clientY
							}
						},
						node: domNode,

						//drag&drop handlers
						onDragEnter: _this.activateDropTarget.bind(_this),
						onDragLeave: _this.deactivateDropTarget.bind(_this),
						onDrop: onDrop,

						//slot data variables.
						contentId: _this.slotDataItemHandler.getContentId(),
						slot: _this.slotDataItemHandler.getSlotAPI(),
						indexInSlot: _this.slotDataItemHandler.indexInSlot,
						addAfter: _this.addAfter,
						isVisOverlay: _this.isVisOverlay
					};
				}
			});
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			this.dndManager.deregisterDropTarget(this.domNode);
		}
	}, {
		key: 'updateDropTarget',
		value: function updateDropTarget(slotDataItemHandler) {
			if (this.dndManager) {
				this.slotDataItemHandler = slotDataItemHandler;
				this._setupDnD();
			}
		}
	}, {
		key: 'activateDropTarget',
		value: function activateDropTarget() {
			(0, _jquery2.default)(this.domNode).toggleClass(this.className, true);
			if (this.onDragEnter) {
				this.onDragEnter();
			}
		}
	}, {
		key: 'deactivateDropTarget',
		value: function deactivateDropTarget() {
			(0, _jquery2.default)(this.domNode).toggleClass(this.className, false);
			if (this.onDragLeave) {
				this.onDragLeave();
			}
		}
	}, {
		key: 'onDragMove',
		value: function onDragMove(dragObject, dropNode, event) {
			var _this2 = this;

			var slotEditorNode = (0, _jquery2.default)(dropNode).closest('.slotEditor').get(0);
			if (slotEditorNode) {
				(0, _utils.handleScroll)(event, slotEditorNode, function () {
					return _this2.dndManager && _this2.dndManager.reassessContainer(slotEditorNode);
				});
			}
			this.activateDropTarget();
		}

		/**
   * @param dndManager - the dndManager to initialize the drag within
   * @param cbGetSlotDataItemHandler - a callback function which should be called when starting any drag to get the up-to-date item data handler.
   */

	}, {
		key: 'initializeDndSource',
		value: function initializeDndSource(dndManager, cbGetSlotDataItemHandler, iconsFeature, startDragCallBack) {
			var _this3 = this;

			// Separate mouse and touch event handlers for defect 241719
			(0, _jquery2.default)(this.domNode).on('mousedown', {}, function (event) {
				if (startDragCallBack) {
					startDragCallBack();
				}
				_this3._startDrag({
					dndManager: dndManager,
					event: event,
					cbGetSlotDataItemHandler: cbGetSlotDataItemHandler,
					iconsFeature: iconsFeature
				});
				return true;
			});

			(0, _jquery2.default)(this.domNode).on('touchstart', {}, function (event) {
				if (startDragCallBack) {
					startDragCallBack();
				}
				_this3._touchStart({
					dndManager: dndManager,
					event: event,
					cbGetSlotDataItemHandler: cbGetSlotDataItemHandler,
					iconsFeature: iconsFeature
				});
				return true;
			});

			(0, _jquery2.default)(this.domNode).on('touchend touchcancel', {}, function () {
				return _this3._touchEnd();
			});
		}

		// defect 241719
		// after touchstart, wait short time to start drag process if still touch,
		// so that it can reduce change of ambiguous event with scrolling of the slot editor

	}, {
		key: '_touchStart',
		value: function _touchStart(options) {
			this.timer = setTimeout(function () {
				this._touchStartDrag(options);
			}.bind(this), SLOT_ITEM_TOUCH_DRAG_DURATION);
		}
	}, {
		key: '_touchEnd',
		value: function _touchEnd() {
			if (this.timer) {
				clearTimeout(this.timer);
			}
			this.timer = null;
		}
	}, {
		key: '_touchStartDrag',
		value: function _touchStartDrag(options) {
			if (this.timer) {
				this._startDrag(options);
			}
		}
	}, {
		key: '_startDrag',
		value: function _startDrag(options) {
			var $avatar = (0, _jquery2.default)('<div style="position:absolute; z-index:10000;"/>');

			var $draggedNode = (0, _jquery2.default)(this.domNode).clone().addClass('draggedNode');

			var _domNode$getBoundingC = this.domNode.getBoundingClientRect(),
			    width = _domNode$getBoundingC.width;

			$draggedNode.css({
				width: width,
				cursor: 'default'
			});
			if (options.iconsFeature) {
				var disableIcon = options.iconsFeature.getIcon('common-nodrop');
				if (disableIcon) {
					var $nodropSign = (0, _jquery2.default)('<div class="nodrop is-hidden">\n\t\t\t\t\t\t<svg class="svgIcon">\n\t\t\t\t\t\t\t<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#' + disableIcon.id + '">\n\t\t\t\t\t\t\t</use>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t</div>');
					$draggedNode.find('.bi-common-field-item__nameLine__draggable').remove();
					$draggedNode.find('.bi-common-field-item__nameLine').prepend($nodropSign);
				}
			}
			$avatar.append($draggedNode);

			var sourceSlotDataItemHandler = options.cbGetSlotDataItemHandler();
			options.dndManager.startDrag({
				event: options.event,
				type: 'SLOT_ITEM',
				data: {
					source: {
						slot: sourceSlotDataItemHandler.getSlotAPI(),
						indexInSlot: sourceSlotDataItemHandler.indexInSlot
					}
				},
				callerCallbacks: {
					onMove: this._onMove.bind(this)
				},
				avatar: $avatar,
				moveXThreshold: 20,
				moveYThreshold: 20
			});
		}
	}, {
		key: '_onMove',
		value: function _onMove(event) {
			var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var dragObject = payload.dragObject;

			if (dragObject) {
				var avatar = dragObject.avatar;

				if (avatar) {
					var $avatar = (0, _jquery2.default)(avatar);
					var $nodrop = $avatar.find('.nodrop');
					if ($nodrop.length) {
						var dropTargetNode = payload.dropTargetNode;

						if (!dropTargetNode) {
							// no payload.dropTargetNode means currenly you cannot drop here, so we show `not allowed drop sign`
							$nodrop.toggleClass('is-hidden', false);
						} else {
							// else payload.dropTargetNode exists,
							// if the drop target is not `.slotEditor` (which is used for drag auto scroll ),
							// then means currenly you can REALLY drop the slot item here, so we does not show `not allowed drop sign`
							var isDropTargetNotSlotEditor = !(dropTargetNode.classList && dropTargetNode.classList.contains('slotEditor'));
							$nodrop.toggleClass('is-hidden', isDropTargetNotSlotEditor);
						}
					}
				}
			}
		}
	}]);

	return DndSlotItemHandler;
}();

exports.default = DndSlotItemHandler;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class; /*
             *+------------------------------------------------------------------------+
             *| Licensed Materials - Property of IBM
             *| IBM Cognos Products: Explore
             *| (C) Copyright IBM Corp. 2020, 2021
             *|
             *| US Government Users Restricted Rights - Use, duplication or disclosure
             *| restricted by GSA ADP Schedule Contract with IBM Corp.
             *+------------------------------------------------------------------------+
             */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _baUiCarbonToolkit = __webpack_require__(5);

var _mobxReact = __webpack_require__(11);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _debounce = __webpack_require__(34);

var _debounce2 = _interopRequireDefault(_debounce);

__webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BASE_CLASS_NAME = 'dropdownWrapper';
var BLUR_TIME = 350;

var FieldDropdown = (0, _mobxReact.observer)(_class = function (_Component) {
	_inherits(FieldDropdown, _Component);

	function FieldDropdown(props) {
		_classCallCheck(this, FieldDropdown);

		var _this = _possibleConstructorReturn(this, (FieldDropdown.__proto__ || Object.getPrototypeOf(FieldDropdown)).call(this, props));

		_this.scrollToDropdown = function () {
			if (_this.dropdownRef.current) {
				var differenceRect = _this.dropdownRef.current.getBoundingClientRect().bottom - window.innerHeight;
				if (differenceRect > 300) {
					var slotEditorNode = _this.dropdownRef.current.closest('.slotEditor');
					slotEditorNode.scrollTop = differenceRect;
				}
			}
		};

		_this.onChange = function (value) {
			_this.setState({
				userTextInput: value
			});
		};

		_this.handleEscapeDropdown = function (event) {
			if (event.key === 'Escape') {
				_this.props.onBlur();
			}
		};

		_this.handleKeyDown = function (event) {
			if (event.key === 'ArrowDown') {
				var currentDropNode = _this.dropdownRef.current;
				var muiList = (0, _jquery2.default)(currentDropNode).find('div.ba-common-list')[0];
				if (muiList) {
					event.preventDefault();
					muiList.focus();
				}
			} else if (event.key === 'Enter' && _this.state.userTextInput === '') {
				event.preventDefault();
				/* when replaceSlotItem = true, we want to modify slot item,
     * in this case delete when nothing is selected,
     * otherwise close the dropdown */
				if (_this.props.replaceSlotItem) {
					_this.props.a11Y.deleteSlotItem(_this.props.slotDataItemHandler);
				} else {
					_this.props.onBlur();
				}
			}
		};

		_this.onBlur = function () {
			_this.blurTimer = setTimeout(_this.props.onBlur, BLUR_TIME);
		};

		_this.onFocus = function () {
			if (_this.blurTimer) {
				clearTimeout(_this.blurTimer);
				_this.blurTimer = null;
			}
		};

		_this.state = {
			userTextInput: _this.props.textValue
		};
		_this.dropdownRef = _react2.default.createRef();
		return _this;
	}

	_createClass(FieldDropdown, [{
		key: 'render',
		value: function render() {
			var dropdownStyle = {
				'max-height': this.props.getDropdownMaxHeight() > 0 ? this.props.getDropdownMaxHeight() + 'px' : 'none'
			};
			var dropdownContent = _react2.default.createElement(
				'div',
				{
					className: 'ba-common-dropdown dropdown',
					ref: this.dropdownRef,
					style: dropdownStyle
				},
				_react2.default.createElement(
					_baUiCarbonToolkit.Collapse,
					{
						isOpened: this.props.open,
						autoUnmount: true
						/* Has to use this prop to control if we want animation when dropdown content changes, check https://github.com/nkbt/react-collapse */
						, hasNestedCollapse: true,
						forceInitialAnimation: true,
						onRest: this.scrollToDropdown
					},
					this._renderMetadataTree()
				)
			);

			return _react2.default.createElement(
				'div',
				{
					className: BASE_CLASS_NAME,
					onBlur: this.onBlur,
					onFocus: this.onFocus,
					onKeyDown: this.handleEscapeDropdown
				},
				this._renderTextInput(),
				dropdownContent
			);
		}
	}, {
		key: '_renderTextInput',
		value: function _renderTextInput() {
			var DEBOUNCE_WAIT = 250; //ms
			var truncatedTextStyle = {
				width: '100%',
				height: 40
			};
			return _react2.default.createElement(_baUiCarbonToolkit.TextInput, {
				className: 'itemInput',
				noBottomBorder: true,
				value: this.state.userTextInput,
				autoFocus: true,
				onChange: (0, _debounce2.default)(this.onChange.bind(this), DEBOUNCE_WAIT),
				onKeyDown: (0, _debounce2.default)(this.handleKeyDown.bind(this), DEBOUNCE_WAIT),
				style: truncatedTextStyle
			});
		}

		/* setting timeout to prevent dropdown from closing
  when tabbing into it onBlur is called before onFocus*/

	}, {
		key: 'performSelection',
		value: function performSelection(selectedValue) {
			this.props.slotDataItemHandler.insertItemFromTypeInSlot(selectedValue, this.props.sourceId, { replaceSlotItem: this.props.replaceSlotItem, parentNode: this.props.parentNode });
			this.props.onBlur();
		}
	}, {
		key: '_renderMetadataTree',
		value: function _renderMetadataTree() {
			var includeOptions = null;
			var context = this.props.slotDataItemHandler.getPickTreeContext && this.props.slotDataItemHandler.getPickTreeContext(this.props.replaceSlotItem);
			return this.props.dashboardApi.getFeature('DataSources.UI').getPickTree(this.props.sourceId, this.state.userTextInput, this.performSelection.bind(this), includeOptions, context);
		}
	}]);

	return FieldDropdown;
}(_react.Component)) || _class;

FieldDropdown.propTypes = {
	a11Y: _propTypes2.default.object,
	open: _propTypes2.default.bool.isRequired,
	textValue: _propTypes2.default.string,
	dashboardApi: _propTypes2.default.object.isRequired,
	getDropdownMaxHeight: _propTypes2.default.func.isRequired,
	sourceId: _propTypes2.default.string.isRequired,
	onBlur: _propTypes2.default.func.isRequired,
	replaceSlotItem: _propTypes2.default.bool.isRequired,
	parentNode: _propTypes2.default.node,
	slotDataItemHandler: _propTypes2.default.object.isRequired
};

FieldDropdown.defaultProps = {
	textValue: '',
	a11Y: undefined,
	onItemSelected: function onItemSelected() {}
};

exports.default = FieldDropdown;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(36);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(20);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(5);

var _FieldDropdown = __webpack_require__(18);

var _FieldDropdown2 = _interopRequireDefault(_FieldDropdown);

var _mobxReact = __webpack_require__(11);

var _mobxStateTree = __webpack_require__(3);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _utils = __webpack_require__(7);

__webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var MAX_HEIGHT = 500;

var SlotItemPlaceholder = function (_Component) {
	_inherits(SlotItemPlaceholder, _Component);

	function SlotItemPlaceholder(props) {
		_classCallCheck(this, SlotItemPlaceholder);

		var _this = _possibleConstructorReturn(this, (SlotItemPlaceholder.__proto__ || Object.getPrototypeOf(SlotItemPlaceholder)).call(this, props));

		_this._placeholderTypeInOn = function () {
			_this.setState({ isTypeInMode: true });
		};

		_this._placeholderTypeInOff = function () {
			_this.setState({ isTypeInMode: false });
		};

		_this._placeholderDropzoneOn = function () {
			var slotPlaceholderStateModel = _this.props.slotPlaceholderStateModel;

			if ((0, _mobxStateTree.isAlive)(slotPlaceholderStateModel)) {
				slotPlaceholderStateModel.setActivePlaceholderExists(true);
			}
			_this.setState({ showDropzone: true });
		};

		_this._placeholderDropzoneOff = function () {
			var slotPlaceholderStateModel = _this.props.slotPlaceholderStateModel;

			if ((0, _mobxStateTree.isAlive)(slotPlaceholderStateModel)) {
				slotPlaceholderStateModel.setActivePlaceholderExists(false);
			}
			_this.setState({ showDropzone: false });
		};

		_this.state = {
			isTypeInMode: false,
			showDropzone: false
		};
		_this.placeholderRef = _react2.default.createRef();
		return _this;
	}

	_createClass(SlotItemPlaceholder, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			var options = {
				onDragEnter: this._placeholderDropzoneOn.bind(this),
				onDragLeave: this._placeholderDropzoneOff.bind(this),
				getDndManager: function getDndManager(dndManager) {
					_this2._dndManager = dndManager;
				}
			};
			this.props.initializeDnd(this.placeholderRef.current, options);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _this3 = this;

			if (this.state.showDropzone !== prevState.showDropzone) {
				var slotNode = (0, _jquery2.default)(this.placeholderRef.current).closest('.slotEditor__slots__slot').get(0);
				// if showDropzone state changes, and if we are dragging now,
				// we call reassessContainer to reassess the drop targets inside `slot`
				if (slotNode && this._dndManager && this._dndManager.dragObject) {
					this._dndManager.reassessContainer(slotNode);
				}
			}
			if (prevProps.slotDataItemHandler !== this.props.slotDataItemHandler) {
				var options = {
					onDragEnter: this._placeholderDropzoneOn.bind(this),
					onDragLeave: this._placeholderDropzoneOff.bind(this),
					getDndManager: function getDndManager(dndManager) {
						_this3._dndManager = dndManager;
					}
				};
				this.props.initializeDnd(this.placeholderRef.current, options);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this._dndManager) {
				this._dndManager.deregisterDropTarget(this.placeholderRef.current);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'slotPlaceholder',
					ref: this.placeholderRef
				},
				_react2.default.createElement('div', { className: 'slotPlaceholder__hoverIndicator' }),
				this._renderItem()
			);
		}
	}, {
		key: 'shouldRenderPlaceholder',


		/**
   * @returns {boolean} indicating if placeholder should be rendered
   * rules to render placeholder:
   * 1. this slot can accept more items and
   * there are no other placeholders currently rendered in this slot and
   * this item is the last one in the slot
   * 2. state showDropzone is true -> user is dragging metadata item on top of this placeholder
   */
		value: function shouldRenderPlaceholder() {
			var _props = this.props,
			    slotPlaceholderStateModel = _props.slotPlaceholderStateModel,
			    indexInSlot = _props.indexInSlot,
			    numberItemsInSlot = _props.numberItemsInSlot,
			    canAcceptMoreItems = _props.canAcceptMoreItems;


			if (!slotPlaceholderStateModel || !slotPlaceholderStateModel.getActivePlaceholderExists() && canAcceptMoreItems) {
				return numberItemsInSlot === indexInSlot + 1;
			}
			return this.state.showDropzone;
		}
	}, {
		key: '_renderItem',
		value: function _renderItem() {
			var _this4 = this;

			if (this.shouldRenderPlaceholder()) {
				this.sourceId = this.props.slotDataItemHandler.getDatasourceId() || (0, _utils.getDataSourceIdTypeIn)(this.props.dashboardApi);
				return _react2.default.createElement(
					'div',
					{ className: 'slotPlaceholder__itemPlaceholder',
						tabIndex: '0',
						onClick: this._placeholderTypeInOn,
						onKeyUp: function onKeyUp(event) {
							return _this4.props.a11Y.handleOpenTypeInDropdown(event, _this4._placeholderTypeInOn.bind(_this4));
						}
					},
					this.state.isTypeInMode && this.sourceId ? this._renderFieldDropdown() : _react2.default.createElement(_baUiCarbonToolkit.Label, { label: _StringResources2.default.get('placeholderDropzone'), className: 'slotPlaceholder__itemPlaceholder__actionLabel' })
				);
			}
		}
	}, {
		key: '_renderFieldDropdown',
		value: function _renderFieldDropdown() {
			return _react2.default.createElement(_FieldDropdown2.default, {
				a11Y: this.props.a11Y,
				open: this.state.isTypeInMode,
				dashboardApi: this.props.dashboardApi,
				getDropdownMaxHeight: this.getDropdownMaxHeight,
				onBlur: this._placeholderTypeInOff,
				slotDataItemHandler: this.props.slotDataItemHandler,
				sourceId: this.sourceId,
				parentNode: this.props.parentNode,
				replaceSlotItem: false
			});
		}
	}, {
		key: 'getDropdownMaxHeight',
		value: function getDropdownMaxHeight() {
			return MAX_HEIGHT;
		}
	}]);

	return SlotItemPlaceholder;
}(_react.Component);

SlotItemPlaceholder.propTypes = {
	a11Y: _propTypes2.default.object.isRequired,
	indexInSlot: _propTypes2.default.number,
	numberItemsInSlot: _propTypes2.default.number,
	canAcceptMoreItems: _propTypes2.default.bool,
	slotDataItemHandler: _propTypes2.default.object.isRequired,
	dashboardApi: _propTypes2.default.object.isRequired,
	initializeDnd: _propTypes2.default.func.isRequired,
	parentNode: _propTypes2.default.node,
	slotPlaceholderStateModel: _propTypes2.default.object
};

SlotItemPlaceholder.defaultProps = {
	indexInSlot: 0,
	numberItemsInSlot: 1,
	slotPlaceholderStateModel: undefined,
	canAcceptMoreItems: true
};

exports.default = (0, _mobxReact.observer)(SlotItemPlaceholder);

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(25);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _SlotEditorDOMAPI = __webpack_require__(26);

var _SlotEditorDOMAPI2 = _interopRequireDefault(_SlotEditorDOMAPI);

var _SlotEditor = __webpack_require__(27);

var _SlotEditor2 = _interopRequireDefault(_SlotEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var APIFactory = __webpack_require__(15);

var SlotEditorDOM = function () {
	function SlotEditorDOM(_ref) {
		var features = _ref.features;

		_classCallCheck(this, SlotEditorDOM);

		this._dashboardApi = features.API;
		this._slideout = features.InAppSlideoutDOM;
		this._slotEditorState = features.SlotEditorState;
		this._api = null;
		this._parent = null;
		this._extensions = [];

		this._api = APIFactory.createAPI(this, [_SlotEditorDOMAPI2.default]);
		this._slideout.registerView(this.getProviderId(), this);
	}

	_createClass(SlotEditorDOM, [{
		key: 'getAPI',
		value: function getAPI() {
			return this._api;
		}
	}, {
		key: 'addExtension',
		value: function addExtension(extension) {
			this._extensions.push(extension);
		}
	}, {
		key: 'getProviderId',
		value: function getProviderId() {
			return this._slotEditorState.getProviderId();
		}
	}, {
		key: 'render',
		value: function render(options) {
			var _this = this;

			var _ref2 = options || {},
			    _ref2$parentNode = _ref2.parentNode,
			    parentNode = _ref2$parentNode === undefined ? null : _ref2$parentNode;

			if (parentNode && document.body.contains(parentNode)) {
				if (this._parent !== parentNode) {
					//before a new render, clear previous rendered SlotEditor
					this.unmount();
					this._parent = parentNode;
					return new Promise(function (resolve) {
						_reactDom2.default.render(_react2.default.createElement(_SlotEditor2.default, {
							dndManager: _this._dashboardApi.getDashboardSvc('.DndManager'),
							slotEditorModel: _this._slotEditorState.getModel(),
							logger: _this._dashboardApi.getService(_this._dashboardApi.GLOBAL_SERVICES.LOGGER),
							extensions: _this._extensions
						}), parentNode, function () {
							return resolve();
						});
					});
				}
			}

			return Promise.resolve(null);
		}
	}, {
		key: 'unmount',
		value: function unmount() {
			if (this._parent) {
				_reactDom2.default.unmountComponentAtNode(this._parent);
				this._parent = null;
			}
		}
	}, {
		key: 'destroy',
		value: function destroy() {
			this.unmount();
			this._api = null;
			this._dashboardApi = null;
			this._slotEditorState = null;
			this._slideout = null;
		}
	}]);

	return SlotEditorDOM;
}();

module.exports = SlotEditorDOM;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_25__;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var SlotEditorDOMAPI = function () {
	function SlotEditorDOMAPI() {
		_classCallCheck(this, SlotEditorDOMAPI);
	}

	_createClass(SlotEditorDOMAPI, [{
		key: "render",

		/**
   * @function SlotEditorDOMAPI#render
   * @description Renders slots in a given container
   * @param {Object} options
   * @param {Object} options.parentNode - the parent dom node for rendering the slots editor
   */
		value: function render() {}

		/**
   * @function SlotEditorDOMAPI#unmount
   * @description unmount slots
   */

	}, {
		key: "unmount",
		value: function unmount() {}

		/**
   * @function SlotEditorDOMAPI#getProviderId
   * @description Returns the provider id for the feature
   * @return {String} DOM feature provider id
   */

	}, {
		key: "getProviderId",
		value: function getProviderId() {}
	}, {
		key: "addExtension",
		value: function addExtension() {}
	}]);

	return SlotEditorDOMAPI;
}();

exports.default = SlotEditorDOMAPI;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ErrorBoundary = __webpack_require__(28);

var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);

var _SlotEditorView = __webpack_require__(29);

var _SlotEditorView2 = _interopRequireDefault(_SlotEditorView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2019, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * The SlotEditor component is responsible for editing of the slots/filters for the widget whose api is provided.
 */
var SlotEditor = function (_Component) {
	_inherits(SlotEditor, _Component);

	function SlotEditor(props) {
		_classCallCheck(this, SlotEditor);

		return _possibleConstructorReturn(this, (SlotEditor.__proto__ || Object.getPrototypeOf(SlotEditor)).call(this, props));
	}

	_createClass(SlotEditor, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    slotEditorModel = _props.slotEditorModel,
			    dndManager = _props.dndManager,
			    logger = _props.logger,
			    extensions = _props.extensions;

			return _react2.default.createElement(
				_ErrorBoundary2.default,
				{
					logger: logger
				},
				_react2.default.createElement(_SlotEditorView2.default, {
					dndManager: dndManager,
					slotEditorModel: slotEditorModel,
					extensions: extensions
				})
			);
		}
	}]);

	return SlotEditor;
}(_react.Component);

SlotEditor.propTypes = {
	dndManager: _propTypes2.default.object.isRequired,
	slotEditorModel: _propTypes2.default.object.isRequired,
	logger: _propTypes2.default.object.isRequired,
	extensions: _propTypes2.default.array
};

exports.default = SlotEditor;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2019
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var ErrorBoundary = function (_Component) {
	_inherits(ErrorBoundary, _Component);

	function ErrorBoundary(props) {
		_classCallCheck(this, ErrorBoundary);

		var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

		_this.state = { hasError: false };
		return _this;
	}

	_createClass(ErrorBoundary, [{
		key: 'componentDidCatch',
		value: function componentDidCatch(error, errorInfo) {
			var logger = this.props.logger;

			if (logger) {
				// logging error message
				logger.error(errorInfo.componentStack /* information about which component threw the error. */);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			if (this.state.hasError) {
				// TODO: error screen when we encounter error
				return null;
			}
			return this.props.children;
		}
	}], [{
		key: 'getDerivedStateFromError',
		value: function getDerivedStateFromError() /*error*/{
			// Update state so the next render will show the fallback UI.
			return { hasError: true };
		}
	}]);

	return ErrorBoundary;
}(_react.Component);

ErrorBoundary.propTypes = {
	logger: _propTypes2.default.object.isRequired,
	children: _propTypes2.default.any
};

ErrorBoundary.defaultProps = {
	children: []
};
exports.default = ErrorBoundary;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _mobxReact = __webpack_require__(11);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _SlotEditorSlot = __webpack_require__(30);

var _SlotEditorSlot2 = _interopRequireDefault(_SlotEditorSlot);

var _SlotEditorA11YHandler = __webpack_require__(59);

var _SlotEditorA11YHandler2 = _interopRequireDefault(_SlotEditorA11YHandler);

var _baUiCarbonToolkit = __webpack_require__(5);

var _SlotEditorEmptyState = __webpack_require__(64);

var _SlotEditorEmptyState2 = _interopRequireDefault(_SlotEditorEmptyState);

var _mobxStateTree = __webpack_require__(3);

var _ScrollableDragHandler = __webpack_require__(67);

var _ScrollableDragHandler2 = _interopRequireDefault(_ScrollableDragHandler);

__webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2019, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

/**
 * The SlotEditor View
 */
var SlotEditorView = function (_Component) {
	_inherits(SlotEditorView, _Component);

	function SlotEditorView(props) {
		_classCallCheck(this, SlotEditorView);

		//Handle slot-editor-specific accessibility actions (eg swapping slot items etc.)
		var _this = _possibleConstructorReturn(this, (SlotEditorView.__proto__ || Object.getPrototypeOf(SlotEditorView)).call(this, props));

		_this._initializeScrollDragSupport = function () {
			var dndManagerPromise = _this.props.dndManager;

			dndManagerPromise && dndManagerPromise.then(function (dndManager) {
				if (_this.slotEditorRef.current) {
					_this.scrollableDragHandler = new _ScrollableDragHandler2.default({
						scrollableContainer: _this.slotEditorRef.current,
						dndManager: dndManager
					});
					_this.dropTarget = dndManager.addDropTarget(_this.slotEditorRef.current, _this.scrollableDragHandler);
				}
			});
		};

		_this.a11YHandler = new _SlotEditorA11YHandler2.default();
		_this.state = {
			needsRefresh: null
		};
		_this.slotEditorRef = _react2.default.createRef();
		return _this;
	}

	_createClass(SlotEditorView, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this._initializeScrollDragSupport();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.dropTarget && this.dropTarget.remove();
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{
					ref: this.slotEditorRef,
					className: 'slotEditor'
				},
				this.renderContent()
			);
		}
	}, {
		key: 'renderContent',
		value: function renderContent() {
			var slotEditorModel = this.props.slotEditorModel;

			if (!slotEditorModel || !(0, _mobxStateTree.isAlive)(slotEditorModel)) {
				// unable to render the view if the model is dead
				return null;
			}
			var selectedContent = slotEditorModel.selectedContents[0];
			var SLOT_EDITOR_STATES = slotEditorModel.SLOT_EDITOR_STATES;

			var currentState = slotEditorModel.slotEditorState;
			if (currentState === SLOT_EDITOR_STATES.DISPLAY) {

				if (!this._canRenderSlotEditor(selectedContent)) {
					return this._renderEmptyState(SLOT_EDITOR_STATES, SLOT_EDITOR_STATES.EMPTY.NO_VIS_CREATED);
				}

				var result = this.renderSlotsAndExtensions();
				if (result) {
					return result;
				} else {
					return this._renderEmptyState(SLOT_EDITOR_STATES);
				}
			} else {
				return this._renderEmptyState(SLOT_EDITOR_STATES, currentState);
			}
		}
	}, {
		key: '_getSlotsSection',
		value: function _getSlotsSection() {
			var slotEditorModel = this.props.slotEditorModel;

			var slotInfo = slotEditorModel.getSlotInfo();
			return _react2.default.createElement(
				'div',
				{ className: 'slotEditor__slots' },
				slotInfo.length > 1 ? this._renderLayersAndSlots(slotInfo) : this._renderSlots(slotInfo[0].slotAPIs)
			);
		}
	}, {
		key: 'renderSlotsAndExtensions',
		value: function renderSlotsAndExtensions() {
			var slotEditorModel = this.props.slotEditorModel;

			var slotInfo = slotEditorModel.getSlotInfo();
			var sections = [{
				index: 0,
				render: this._getSlotsSection.bind(this)
			}];

			if (this.props.extensions !== undefined) {
				sections = sections.concat(this.props.extensions);
			}
			var sorted_sections = sections.sort(function (a, b) {
				return a.index - b.index;
			});

			if (slotInfo.length > 0) {
				return _react2.default.createElement(
					_react2.default.Fragment,
					null,
					sorted_sections.map(function (section) {
						return section.render();
					})
				);
			}
		}
	}, {
		key: '_canRenderSlotEditor',
		value: function _canRenderSlotEditor(content) {
			// in some edge cases, there is no `visualization` in `content`, we cannot display slot editor without `visualization`
			return !!(content && content.getFeature('Visualization'));
		}
	}, {
		key: '_renderEmptyState',
		value: function _renderEmptyState(SLOT_EDITOR_STATES, currentSlotEditorState) {
			switch (currentSlotEditorState) {
				case SLOT_EDITOR_STATES.EMPTY.NO_VIS_CREATED:
					return this._getEmptyState(_StringResources2.default.get('slotEditor_emptyState_vis_not_created_title'), _StringResources2.default.get('slotEditor_emptyState_vis_not_created_description'));
				case SLOT_EDITOR_STATES.EMPTY.NOT_SUPPORT_SLOTS:
					return this._getEmptyState(_StringResources2.default.get('slotEditor_emptyState_widget_not_support_slot_selected_title'), _StringResources2.default.get('slotEditor_emptyState_widget_not_support_slot_selected_description'));
				case SLOT_EDITOR_STATES.EMPTY.NO_VIS_SELECTED:
					return this._getEmptyState(_StringResources2.default.get('slotEditor_emptyState_no_visualization_selected_title'), _StringResources2.default.get('slotEditor_emptyState_no_visualization_selected_description'));
				case SLOT_EDITOR_STATES.EMPTY.MUILTI_SELECTION:
					return this._getEmptyState(_StringResources2.default.get('slotEditor_emptyState_multiple_visualizations_selected_title'), _StringResources2.default.get('slotEditor_emptyState_multiple_visualizations_selected_description'));
				case SLOT_EDITOR_STATES.EMPTY.ERROR:
					return this._getEmptyState(_StringResources2.default.get('slotEditor_emptyState_visualization_has_error_title'), null, 'error');
				default:
					return this._getEmptyState();
			}
		}
	}, {
		key: '_getEmptyState',
		value: function _getEmptyState(title, description, type) {
			return _react2.default.createElement(_SlotEditorEmptyState2.default, {
				title: title,
				description: description,
				type: type
			});
		}

		/**
   * For the multi-layer case, we need to draw the layer headings and the slots per layer.
   * @param slotInfoByLayer - a structure containing the layerId and the array of slotAPI's assigned to that layer.
   */

	}, {
		key: '_renderLayersAndSlots',
		value: function _renderLayersAndSlots(slotInfoByLayer) {
			var _this2 = this;

			return slotInfoByLayer.map(function (slotInfoByLayerEntry) {
				if (!slotInfoByLayerEntry.isHideLayer) {
					return _react2.default.createElement(
						_baUiCarbonToolkit.Accordion,
						{ key: slotInfoByLayerEntry.layerId },
						_react2.default.createElement(
							_baUiCarbonToolkit.AccordionItem,
							{
								icon: 'right',
								itemName: slotInfoByLayerEntry.layerCaption,
								open: slotInfoByLayerEntry.open,
								fullWidth: true
							},
							_this2._renderSlots(slotInfoByLayerEntry.slotAPIs, slotInfoByLayerEntry.layerId, '__multilayer' /*customeClass*/)
						)
					);
				} else {
					return _this2._renderSlots(slotInfoByLayerEntry.slotAPIs);
				}
			});
		}

		/**
   * Called to render the data slots (or a single layer worth of slots for the multi-layer scenario).
   * @param slotAPIs - the slots to render
   * @param pLayerId - (optional) the layerId to render
   * @param className - (optional) the custom class name to render
   */

	}, {
		key: '_renderSlots',
		value: function _renderSlots(slotAPIs, pLayerId, className) {
			var _this3 = this;

			var layerId = pLayerId || '';
			return slotAPIs.map(function (slotAPI) {
				return slotAPI.getDefinition().isHidden() ? [] : _react2.default.createElement(_SlotEditorSlot2.default, {
					className: className,
					key: layerId + slotAPI.getDefinition().getId(),
					slotAPI: slotAPI,
					dataItemAPIs: slotAPI.getDataItemList(),
					a11Y: _this3.a11YHandler,
					slotDataItemHandler: _this3.props.slotEditorModel.getSlotDataItemHandler(slotAPI, -1),
					slotEditorModel: _this3.props.slotEditorModel,
					dndManager: _this3.props.dndManager
				});
			});
		}
	}]);

	return SlotEditorView;
}(_react.Component);

SlotEditorView.propTypes = {
	dndManager: _propTypes2.default.object.isRequired,
	slotEditorModel: _propTypes2.default.object.isRequired,
	extensions: _propTypes2.default.array
};

exports.default = (0, _mobxReact.observer)(SlotEditorView);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _baUiCarbonToolkit = __webpack_require__(5);

var _SlotEditorItem = __webpack_require__(31);

var _SlotEditorItem2 = _interopRequireDefault(_SlotEditorItem);

var _DndSlotItemHandler = __webpack_require__(17);

var _DndSlotItemHandler2 = _interopRequireDefault(_DndSlotItemHandler);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _SlotItemPlaceholder = __webpack_require__(22);

var _SlotItemPlaceholder2 = _interopRequireDefault(_SlotItemPlaceholder);

var _classnames = __webpack_require__(56);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SlotPlaceholderStateModel = __webpack_require__(57);

var _SlotPlaceholderStateModel2 = _interopRequireDefault(_SlotPlaceholderStateModel);

var _mobxStateTree = __webpack_require__(3);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var GlassUtils = __webpack_require__(58);


var _ = __webpack_require__(6); //TODO: should try to remove this dependency
var AGGREGATION_TYPE_MAP = {
	none: 'none',
	countDistinct: 'countDistinct'
};

/**
 * The SlotEditorSlot component is responsible for rendering a single slot and its items.
 * It also manages drag and drop of items or data to the 'slot heading region'.
 */

var SlotEditorSlot = function (_Component) {
	_inherits(SlotEditorSlot, _Component);

	function SlotEditorSlot(props) {
		_classCallCheck(this, SlotEditorSlot);

		var _this = _possibleConstructorReturn(this, (SlotEditorSlot.__proto__ || Object.getPrototypeOf(SlotEditorSlot)).call(this, props));

		_this._applySlotCoachMarks = _.debounce(function () {
			var _this$props = _this.props,
			    slot = _this$props.slotAPI,
			    _this$props$slotDataI = _this$props.slotDataItemHandler,
			    visualization = _this$props$slotDataI.visualization,
			    dashboardApi = _this$props$slotDataI.dashboardApi;

			var slotDef = slot.getDefinition();
			var coachMark = slotDef.getCoachMark();
			var slotId = slotDef.getId();
			var $slotEditorSlot = (0, _jquery2.default)(_this.slotEditorSlotRef.current);
			if (coachMark) {
				var isMapped = slot.getDataItemList().length > 0;
				if (!coachMark.mappedOnly || isMapped) {
					var $el = isMapped ? $slotEditorSlot.find('.slotEditorItem') : $slotEditorSlot;
					if ($el.length) {
						// Make the coachmark unique for each slot of every visualization
						var options = {
							id: visualization.getDefinition().getId() + '#' + slotId,
							$el: $el,
							title: _StringResources2.default.get(coachMark.titleResource),
							contents: _StringResources2.default.get(coachMark.contentResource),
							showPopover: coachMark.showPopover,
							placement: 'bottom'
						};
						dashboardApi.prepareGlassOptions(options);
						GlassUtils.addCoachmark(options);
					}
				}
			} else {
				var $coachMarkNode = $slotEditorSlot.find('.coachMark');
				if ($coachMarkNode.length) {
					var _coachMark = $coachMarkNode[0];
					var coachMarkParent = _coachMark.parentElement;
					if (coachMarkParent) {
						coachMarkParent.classList.remove('coachMarkContainer');
						coachMarkParent.removeAttribute('id');
						coachMarkParent.removeChild(_coachMark);
					}
				}
			}
		});

		_this._initializeDndSupport = function (node) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			//A data slot can be a drop target but not a dragdrop source.
			_this.props.dndManager.then(function (dndManager) {
				if (node) {
					_this.dropSlotItemHandler = new _DndSlotItemHandler2.default({
						domNode: node,
						className: 'dndHover',
						slotDataItemHandler: _this.props.slotDataItemHandler,
						addAfter: true, //The slot placeholder is assigned index -1.  "Dropping after nothing" means inserting before any (or no) items
						dndManager: dndManager,
						onDragEnter: options.onDragEnter,
						onDragLeave: options.onDragLeave
					});
					if (options.getDndManager) {
						options.getDndManager(dndManager);
					}
				}
			});
		};

		_this.slotEditorSlotRef = _react2.default.createRef();
		_this.slotPlaceholderStateModel = _SlotPlaceholderStateModel2.default.create({
			activePlaceholderExists: false
		});
		return _this;
	}

	_createClass(SlotEditorSlot, [{
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this.slotPlaceholderStateModel) {
				(0, _mobxStateTree.destroy)(this.slotPlaceholderStateModel);
			}
			this.dropSlotItemHandler && this.dropSlotItemHandler.destroy();
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this._applySlotCoachMarks();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			this._applySlotCoachMarks();
		}

		/**
   * Apply coach marks on the slot or data item
   * The slot coach mark consists with:
   * - showPopover: boolean flag indicating whether the popover show along with the coach mark.
   * - mappedOnly: boolean flag indicating whether the coach mark applies when the slot is mapped or
   * 		regardless of the mapped state.
   * - titleResource: resource name for the coach title.
   * - contentResource: resource name for the coach content.
   */

	}, {
		key: 'render',


		/**
   * Called to render the data slots (or a single layer worth of slots for the multi-layer scenario).
   * @param slotAPIs - the slots to render
   * @param pLayerId - (optional) the layerId to render
   * @param className - (optional) the custom class name to render
   */
		value: function render() {
			var _this2 = this;

			/* a custom class name will be added iff exists */
			var classes = (0, _classnames2.default)(_defineProperty({
				slotEditor__slots__slot: true
			}, '' + this.props.className, this.props.className));

			var slotDefinition = this.props.slotAPI.getDefinition();
			var slotCaption = slotDefinition.getCaption();
			var slotId = slotDefinition.getId();
			return _react2.default.createElement(
				'div',
				{ ref: this.slotEditorSlotRef, className: classes },
				_react2.default.createElement(
					'div',
					{ className: 'slotEditor__slots__slot__heading',
						'aria-label': slotCaption,
						title: slotCaption,
						role: 'Listbox',
						'data-slot-id': slotId,
						'aria-required': this._isRequiredField(this.props.slotAPI),
						onKeyUp: function onKeyUp(event) {
							return _this2.props.a11Y.slotHandleKeyUp(event, _this2.props.slotDataItemHandler);
						},
						onKeyPress: function onKeyPress(event) {
							return _this2.props.a11Y.handleKeyPress(event, _this2.props.slotDataItemHandler.swapSlotItems.bind(_this2.props.slotDataItemHandler), /*dropAfter*/true);
						} },
					_react2.default.createElement(
						'div',
						{ className: 'slotEditor__slots__slot__heading__container' },
						_react2.default.createElement(
							'div',
							{ className: 'slotEditor__slots__slot__heading__icon' },
							_react2.default.createElement(_baUiCarbonToolkit.SVGIcon, { iconId: this._getSlotIcon(), size: 'small' })
						),
						this._isRequiredField(this.props.slotAPI) ? _react2.default.createElement(
							'div',
							{ className: 'slotEditor__slots__slot__heading__required' },
							_react2.default.createElement(
								'div',
								{ className: 'slotEditor__slots__slot__heading__required__caption' },
								slotCaption,
								_react2.default.createElement(
									'span',
									{ className: 'slotEditor__slots__slot__heading__required__caption__star' },
									'*'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'slotEditor__slots__slot__heading__required__text' },
								_StringResources2.default.get('slotEditorMsg1')
							)
						) : slotCaption
					),
					_react2.default.createElement(
						'div',
						{
							className: 'slotEditor__slots__slot__heading__dropBefore',
							tabIndex: '0'
						},
						this._renderSlotPlaceholder()
					)
				),
				this._renderSlotDataItems()
			);
		}
	}, {
		key: '_isRequiredField',
		value: function _isRequiredField(slotAPI) {
			return !slotAPI.getDefinition().isOptional() && slotAPI.getDefinition().getShowRequiredMarker();
		}
	}, {
		key: '_renderSlotPlaceholder',
		value: function _renderSlotPlaceholder() {
			if (this.props.slotDataItemHandler) {
				return _react2.default.createElement(_SlotItemPlaceholder2.default, {
					a11Y: this.props.a11Y,
					indexInSlot: this.props.slotDataItemHandler.indexInSlot,
					numberItemsInSlot: this.props.dataItemAPIs.length,
					canAcceptMoreItems: this.props.slotDataItemHandler.canAcceptMoreItems(),
					slotDataItemHandler: this.props.slotDataItemHandler,
					dashboardApi: this.props.slotEditorModel.dashboardApi,
					initializeDnd: this._initializeDndSupport.bind(this),
					slotPlaceholderStateModel: this.slotPlaceholderStateModel
				});
			}
		}

		/**
   * Render all data items assigned to this slot.
   */

	}, {
		key: '_renderSlotDataItems',
		value: function _renderSlotDataItems() {
			var _this3 = this;

			if (this.props.dataItemAPIs.length) {
				var slotHasUnavailableColumns = this.props.slotAPI.hasUnavailableMetadataColumns();
				return _.map(this.props.dataItemAPIs, function (dataItemAPI, indexInSlot) {
					var slotId = _this3.props.slotAPI.getDefinition().getId();

					return _react2.default.createElement(_SlotEditorItem2.default, { key: slotId + dataItemAPI.getId(),
						itemName: _this3._getSlotItemLabel(indexInSlot, slotHasUnavailableColumns),
						columnId: dataItemAPI.getColumnId(),
						dashboardApi: _this3.props.slotEditorModel.dashboardApi,
						slotPlaceholderStateModel: _this3.slotPlaceholderStateModel,
						slotDataItemHandler: _this3.props.slotEditorModel.getSlotDataItemHandler(_this3.props.slotAPI, indexInSlot),
						indexInSlot: indexInSlot,
						numberItemsInSlot: _this3.props.dataItemAPIs.length,
						a11Y: _this3.props.a11Y,
						dndManager: _this3.props.dndManager });
				});
			}
		}
	}, {
		key: '_getSlotItemLabel',
		value: function _getSlotItemLabel(itemIndex, slotHasUnavailableColumns) {
			var dataItem = this.props.slotAPI.getDataItemList()[itemIndex];
			var label = dataItem.getLabel();
			if (slotHasUnavailableColumns) {
				// check if the current data item is the missing one
				var metadataColumn = dataItem.getMetadataColumn();
				if (!metadataColumn) {
					label = _StringResources2.default.get('missingColumn', { 'columnLabel': label });
				}
			}
			return label;
		}
		/**
   * Slot icons are retrieved from the dashboard slots and definition.
   * If there is no icon assigned to the slot, the default for category or value is returned.
   * @param slotAPI - the slotAPI to return the icon for.
   */

	}, {
		key: '_getSlotIcon',
		value: function _getSlotIcon() {
			var iconId = this.props.slotAPI.getDefinition().getIcon();
			var iconsFeature = this.props.slotEditorModel.dashboardApi.getFeature('Icons');
			var icon = iconsFeature.getIcon(iconId);
			if (icon) {
				return icon.id;
			}
			return this._getFinalSlotType(this.props.slotAPI) === 'ordinal' ? iconsFeature.getIcon('values').id : iconsFeature.getIcon('category').id;
		}

		/**
  * Return the 'final slot type' ==> meaning that if the slot type is 'any' and data is mapped to the slot,
  * the type of the data will be used to infer the type of the slot.
  * (Not to be confused with getEffectiveType...see below)
  * @param slotAPI - the slotAPI of interest
  * @param [dataItemIndex=0] - the data item in question
  * @returns the final slot type for this slotAPI.
  * TODO: this api returns legacy slot types.  We need to change to categorical and continuous throughout the code.
  * This function is copied from the old SlotAPI.getFinalSlotType
  * Story 295271: Add missing API to get layer caption and to replace the old API slotAPI.itemsNotSupported
  */

	}, {
		key: '_getFinalSlotType',
		value: function _getFinalSlotType(slotAPI) {
			var dataItemIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

			var layerId = slotAPI.getDefinition().getDatasetIdList()[0];
			if (layerId === 'latitude' || layerId === 'longitude') {
				return 'category';
			}
			var slotType = slotAPI.getDefinition().getType();
			if (slotType === 'any') {
				if (this._isMultiMeasuresSlot(slotAPI)) {
					return 'category';
				}
				var mappedDataItem = slotAPI.getDataItemList()[dataItemIndex];
				if (mappedDataItem) {
					if (mappedDataItem.getBinning()) {
						return 'category';
					}
					if (mappedDataItem.getType() === 'attribute') {
						var dataItemAggregationType = mappedDataItem.getAggregation ? mappedDataItem.getAggregation() : mappedDataItem.getAggregationType && mappedDataItem.getAggregationType();
						if (dataItemAggregationType === AGGREGATION_TYPE_MAP.none) {
							return 'category';
						} else {
							return 'ordinal';
						}
					} else if (mappedDataItem.getType() === 'fact') {
						/**
       * - If one of the items in an 'any' slot is a measure, and we have more than one items,
       * then simply consider slot type to be category.
       * - Also look at the 'repeats' attribute by looking at the slot definition. If 'repeats'
       * attribute is there, then it means that we don't stack the data items in this slot. This
       * occurs in all non-VIPR visualizations.
       * - For al non-VIPR visualizations we don't want to enforce
       * the slot type to be a 'category', like we do for all VIPR visualizations.
       * This prevents issues described in defect #255087
       */
						// TODO: repeats (old API)
						if (slotAPI.getDataItemList().length > 1 && !slotAPI.getDefinition().repeats) {
							return 'category';
						} else {
							return 'ordinal';
						}
					}
				}
			}
			return slotType;
		}
	}, {
		key: '_isMultiMeasuresSlot',
		value: function _isMultiMeasuresSlot(slot) {
			return slot.getDataItemList().find(function (dataItem) {
				return dataItem.getColumnId() === '_multiMeasuresSeries';
			});
		}

		/** initializes drag and drop support for placeholder dropzone
   * that is attached to this slot
   * @param node - domNode that dropzone will be initialized on
   * @param options - object that contains callbacks to be passed to and executed in DndHandler
   * @param {Function} [options.onDragEnterExecute] - function to be executed when on Drag Enter event occurs
   * @param {Function} [options.onDragLeaveExecute] - function to be executed when on Drag Leave event occurs
   * @param {Function} [options.getDndManager] - a callback to get dndManager
   */

	}]);

	return SlotEditorSlot;
}(_react.Component);

SlotEditorSlot.propTypes = {
	className: _propTypes2.default.string,
	slotAPI: _propTypes2.default.object,
	dataItemAPIs: _propTypes2.default.array,
	slotEditorModel: _propTypes2.default.object.isRequired,
	dndManager: _propTypes2.default.object.isRequired,
	slotDataItemHandler: _propTypes2.default.object,
	a11Y: _propTypes2.default.object
};

exports.default = SlotEditorSlot;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(14);

var _DndSlotItemHandler = __webpack_require__(17);

var _DndSlotItemHandler2 = _interopRequireDefault(_DndSlotItemHandler);

var _FieldDropdown = __webpack_require__(18);

var _FieldDropdown2 = _interopRequireDefault(_FieldDropdown);

var _SlotEditorItemFlyout = __webpack_require__(48);

var _SlotEditorItemFlyout2 = _interopRequireDefault(_SlotEditorItemFlyout);

var _FieldItem = __webpack_require__(49);

var _FieldItem2 = _interopRequireDefault(_FieldItem);

var _SlotItemPlaceholder = __webpack_require__(22);

var _SlotItemPlaceholder2 = _interopRequireDefault(_SlotItemPlaceholder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var MAX_HEIGHT = 500;
/**
 * The SlotEditorItem component is responsible for the User Interface for a single slot data item
 */

var SlotEditorItem = function (_Component) {
	_inherits(SlotEditorItem, _Component);

	function SlotEditorItem(props) {
		_classCallCheck(this, SlotEditorItem);

		var _this = _possibleConstructorReturn(this, (SlotEditorItem.__proto__ || Object.getPrototypeOf(SlotEditorItem)).call(this, props));

		_this._initializeDropAfterSupport = function (node, options) {
			return _this.props.dndManager.then(function (dndManager) {
				if (node) {
					//Initialize a drop handler 'after node'.
					//Also initialize the node as a drag source.
					_this._dndManager = dndManager;
					_this.dropSlotItemAfterHandler = new _DndSlotItemHandler2.default({
						domNode: node,
						className: 'dndHover',
						slotDataItemHandler: _this.props.slotDataItemHandler,
						addAfter: true,
						dndManager: dndManager,
						onDragEnter: options.onDragEnter,
						onDragLeave: options.onDragLeave
					});
					if (options.getDndManager) {
						options.getDndManager(dndManager);
					}
				}
			});
		};

		_this._showFlyout = function () {
			// don't show flyout when doing DND because the mui three flyout somehow mess up the drag object(see defect CADBLW-5243)
			// don't show flyout if slot menu is open
			if (_this.flyoutTooltipTimer) {
				return;
			}
			_this.flyoutTooltipTimer = setTimeout(function () {
				if (!_this._isDragging() && !_this.props.slotDataItemHandler.isSlotActionMenuOpened()) {
					_this.setState({
						isFlyoutShown: !_this.state.isTypeInMode
					});
				}
			}, 200);
		};

		_this._hideFlyout = function () {
			_this.setState({ isFlyoutShown: false });
			if (_this.flyoutTooltipTimer) {
				clearTimeout(_this.flyoutTooltipTimer);
				_this.flyoutTooltipTimer = null;
			}
		};

		_this._isDragging = function () {
			return !!(_this._dndManager && _this._dndManager.dragObject);
		};

		_this._slotItemTypeInOn = function () {
			_this.setState({
				isTypeInMode: true,
				isFlyoutShown: false
			});
		};

		_this._slotItemTypeInOff = function () {
			_this.setState({ isTypeInMode: false });
			_this._initializeDndSupport();
		};

		_this.state = {
			isFlyoutShown: false,
			isTypeInMode: false
		};
		_this.sourceId = _this.props.slotDataItemHandler.getDatasourceId();
		_this.flyoutTooltipTimer = null;
		return _this;
	}

	_createClass(SlotEditorItem, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this._initializeDndSupport();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			if (prevProps && prevProps.slotDataItemHandler !== this.props.slotDataItemHandler) {
				this.dropSlotItemHandler && this.dropSlotItemHandler.updateDropTarget(this.props.slotDataItemHandler);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.dropSlotItemHandler && this.dropSlotItemHandler.destroy();
		}

		/**
   * A slot item consists of the name, a menu (to launch actions), an itemValues section (for displaying local filters on that item)
   * and an additional 'dropAfter' region which is used to allow a user to drop after to augment a slots definition.
   */

	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				this._renderFlyout(),
				this.state.isTypeInMode && !this.props.slotDataItemHandler.isMeasureGroupItem() ? this._renderFieldDropdown() : _react2.default.createElement(_FieldItem2.default, {
					className: 'slotEditorItem',
					fieldName: this.props.itemName,
					onKeyPress: function onKeyPress(event) {
						return _this2.props.a11Y.handleKeyPress(event, _this2.props.slotDataItemHandler.swapSlotItems.bind(_this2.props.slotDataItemHandler), /*dropAfter*/false);
					},
					onKeyDown: function onKeyDown(event) {
						return _this2.props.a11Y.handleKeyDown(event, { slotDataItemHandler: _this2.props.slotDataItemHandler }, _this2._slotItemTypeInOn);
					},
					onKeyUp: function onKeyUp(event) {
						return _this2.props.a11Y.handleKeyUp(event, { slotDataItemHandler: _this2.props.slotDataItemHandler });
					},
					onMouseEnterCallBack: this._showFlyout.bind(this),
					onMouseLeaveCallBack: this._hideFlyout.bind(this),
					onClick: this._slotItemTypeInOn.bind(this),
					fieldGraphics: this.props.slotDataItemHandler.getGraphicData() ? this.props.slotDataItemHandler.getGraphicData() : undefined,
					showActionMenu: !this.props.slotDataItemHandler.isMeasureGroupItem(),
					onOpenActionMenu: !this.props.slotDataItemHandler.isMeasureGroupItem() ? this._slotActionMenu.bind(this) : undefined,
					filterInfo: this.props.slotDataItemHandler.getFilterStringAndNumber(),
					ref: function ref(fieldItem) {
						if (fieldItem && fieldItem.getDOMNode) {
							_this2.domNode = fieldItem.getDOMNode();
						}
					}
				}),
				_react2.default.createElement(
					'div',
					{ className: 'slotEditorItem__dropAfter',
						onKeyPress: function onKeyPress(event) {
							return _this2.props.a11Y.handleKeyPress(event, _this2.props.slotDataItemHandler.swapSlotItems.bind(_this2.props.slotDataItemHandler), /*dropAfter*/true);
						},
						onKeyUp: function onKeyUp(event) {
							return _this2.props.a11Y.slotHandleKeyUp(event, { slotDataItemHandler: _this2.props.slotDataItemHandler });
						}
					},
					_react2.default.createElement(_SlotItemPlaceholder2.default, {
						a11Y: this.props.a11Y,
						indexInSlot: this.props.indexInSlot,
						numberItemsInSlot: this.props.numberItemsInSlot,
						canAcceptMoreItems: this.props.slotDataItemHandler.canAcceptMoreItems(),
						slotDataItemHandler: this.props.slotDataItemHandler,
						dashboardApi: this.props.dashboardApi,
						slotPlaceholderStateModel: this.props.slotPlaceholderStateModel,
						initializeDnd: this._initializeDropAfterSupport.bind(this)
					})
				)
			);
		}

		//Drag and Drop Support.

	}, {
		key: '_initializeDndSupport',
		value: function _initializeDndSupport() {
			var _this3 = this;

			return this.props.dndManager.then(function (dndManager) {
				if (_this3.domNode) {
					//Initialize a drop handler for both the item node and the 'after node'.
					//Also initialize the node as a drag source.
					_this3._dndManager = dndManager;
					_this3.dropSlotItemHandler = new _DndSlotItemHandler2.default({
						domNode: _this3.domNode,
						className: 'dndHover',
						slotDataItemHandler: _this3.props.slotDataItemHandler,
						addAfter: false,
						dndManager: dndManager
					});

					//We need to set up a callback function when initializing the drag source so that the drag handler is always up-to-date.
					//(not the one at drag drop initialization time!)
					_this3.dropSlotItemHandler.initializeDndSource(_this3._dndManager, _this3._getSlotDataItemHandler.bind(_this3), _this3.props.dashboardApi.getFeature('Icons'), _this3._hideFlyout);
				}
			});
		}

		/** initializes drag and drop support for placeholder dropzone
   * that is attached to this item
   * @param node - domNode that dropzone will be initialized on
   * @param {Function} [options.onDragEnterExecute] - function to be executed when on Drag Enter event occurs
   * @param {Function} [options.onDragLeaveExecute] - function to be executed when on Drag Leave event occurs
   * @param {Function} [options.getDndManager] - a callback to get dndManager
   */

	}, {
		key: '_getSlotDataItemHandler',
		value: function _getSlotDataItemHandler() {
			return this.props.slotDataItemHandler;
		}
	}, {
		key: '_slotActionMenu',
		value: function _slotActionMenu() {
			this.props.slotDataItemHandler.openSlotActionMenu(this.domNode, {
				attachPoint: '.actionmenu',
				reactToolbar: true,
				preferredVertical: true,
				placement: 'bottom'
			});
		}
	}, {
		key: '_renderFlyout',
		value: function _renderFlyout() {
			/* we dont't want to show tooltip if the item is measure group*/
			var shouldRenderFlyout = this.state.isFlyoutShown && this.domNode && !this.props.slotDataItemHandler.isMeasureGroupItem();
			if (shouldRenderFlyout) {
				return _react2.default.createElement(_SlotEditorItemFlyout2.default, {
					domNode: this.domNode,
					dashboardApi: this.props.dashboardApi,
					columnId: this.props.columnId,
					sourceId: this.sourceId,
					onClose: this._hideFlyout
				});
			}
		}
	}, {
		key: '_renderFieldDropdown',
		value: function _renderFieldDropdown() {
			if (this.state.isTypeInMode && !this.props.slotDataItemHandler.isMeasureGroupItem()) {
				return _react2.default.createElement(_FieldDropdown2.default, {
					a11Y: this.props.a11Y,
					open: this.state.isTypeInMode,
					textValue: this.props.itemName,
					dashboardApi: this.props.dashboardApi,
					getDropdownMaxHeight: this.getDropdownMaxHeight,
					onBlur: this._slotItemTypeInOff,
					slotDataItemHandler: this.props.slotDataItemHandler,
					sourceId: this.sourceId,
					replaceSlotItem: true
				});
			}
		}
	}, {
		key: 'getDropdownMaxHeight',
		value: function getDropdownMaxHeight() {
			return MAX_HEIGHT;
		}
	}]);

	return SlotEditorItem;
}(_react.Component);

SlotEditorItem.propTypes = {
	slotPlaceholderStateModel: _propTypes2.default.object.isRequired,
	itemName: _propTypes2.default.string,
	indexInSlot: _propTypes2.default.number.isRequired,
	numberItemsInSlot: _propTypes2.default.number.isRequired,
	itemValues: _propTypes2.default.string,
	dashboardApi: _propTypes2.default.object,
	columnId: _propTypes2.default.string,
	slotDataItemHandler: _propTypes2.default.object.isRequired,
	a11Y: _propTypes2.default.object,
	dndManager: _propTypes2.default.object.isRequired
};

exports.default = SlotEditorItem;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "/**\n* IBM Confidential\n* OCO Source Materials\n* IBM Business Platform: Dashboard\n* (C) Copyright IBM Corp. 2018, 2020\n* The source code for this program is not published or otherwise divested of its trade secrets,\n* irrespective of what has been deposited with the U.S. Copyright Office\n**/\n\n.slotEditor:not(.is-old) {\n  overflow-y: auto;\n  height: 100%;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots .ba-common-accordion:first-child {\n  border-top: 1px solid;\n  border-top-color: #f4f4f4;\n  border-top-color: hsla(var(--ui-02-h, 0), var(--ui-02-s, 0%), var(--ui-02-l, 95.68627%), 1);\n  margin-top: 40px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots .ba-common-accordion {\n  border-top: none;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots .ba-common-accordionItem__button {\n  width: auto;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  margin-top: 16px;\n  margin-right: 16px;\n  margin-left: 16px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot:first-child {\n  margin-top: 24px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot.__multilayer {\n  margin-right: 0;\n  margin-left: 0;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot.__multilayer:first-child {\n  margin-top: 0;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot .dropdownWrapper .itemInput {\n  width: 100%;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__dropzone {\n  padding: 0 16px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__dropzone {\n  padding: 0 16px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column;\n      flex-flow: column;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 0.875rem;\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__indent {\n  width: 16px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__icon {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-right: 8px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__icon svg {\n  fill: #161616;\n  fill: hsla(var(--icon-01-h, 0), var(--icon-01-s, 0%), var(--icon-01-l, 8.62745%), 1);\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__required {\n  -ms-flex: 1 0 auto;\n      flex: 1 0 auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: baseline;\n      align-items: baseline;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__required__caption {\n  font-weight: 600;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__required__caption__star {\n  color: #da1e28;\n  color: hsla(var(--support-01-h, 356.80851), var(--support-01-s, 75.80645%), var(--support-01-l, 48.62745%), 1);\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot__heading__required__text {\n  font-size: 0.75rem;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots__slot > .coachMark {\n  top: 30px;\n  right: 80px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__slots .bi-mui-moserObjectTree {\n  max-height: 500px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters {\n  margin-right: 16px;\n  margin-left: 16px;\n  margin-top: 24px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters.dndHover {\n  background-color: rgba(15, 98, 254, 0.2);\n  background-color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 0.2);\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters__heading__container {\n  font-size: 0.875rem;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding-bottom: 8px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters__heading__icon {\n  padding-right: 8px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters .slotPlaceholder__itemPlaceholder .itemInput {\n  width: 100%;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters__item {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  margin-bottom: 8px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters__item .bi-common-field-item {\n  padding-left: 16px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters__item .bi-common-field-item__nameLine__fieldName {\n  margin-left: 0px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters__item .bi-common-field-item__infoLine__values {\n  margin-left: 0px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__localFilters .bi-mui-moserObjectTree {\n  max-height: 500px;\n}\n\n.slotEditor:not(.is-old) .slotEditor__footer__line {\n  padding-top: 16px;\n  font-size: 14px;\n  display: -ms-flexbox;\n  display: flex;\n  color: #393939;\n  color: hsla(var(--interactive-02-h, 0), var(--interactive-02-s, 0%), var(--interactive-02-l, 22.35294%), 1);\n}\n\n.slotEditor:not(.is-old) .slotEditor__footer__line__icon {\n  margin-right: 8px;\n  margin-left: 16px;\n  color: #8d8d8d;\n  color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n}\n\n.slotEditor:not(.is-old) .ba-common-baseInput > input {\n  box-sizing: border-box;\n}\n\n.highcontrast .slotEditorItem:not(.is-old) {\n  border: 1px solid;\n}\n\n.highcontrast .slotEditor:not(.is-old) .slotEditor__localFilters.dndHover {\n  outline-width: 2px;\n  outline-style: dotted;\n  outline-color: white;\n  outline-color: hsla(var(--inverse-focus-ui-h, 0), var(--inverse-focus-ui-s, 0%), var(--inverse-focus-ui-l, 100%), 1);\n}\n\n.slotEditorItem:not(.is-old) {\n  cursor: pointer;\n}\n\n.slotEditorItem:not(.is-old).selected {\n  border: 2px solid;\n  border-color: #8d8d8d;\n  border-color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n}\n\n.slotEditorItem:not(.is-old).dndHover {\n  outline: #2d74da solid 2px;\n}\n\n.slotEditorItem:not(.is-old).dndHover .bi-common-field-item__nameLine__fieldName .ba-common-truncatedText__text {\n  text-decoration: underline;\n  color: #0f62fe;\n  color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n}\n\n.slotEditorItem:not(.is-old).action-menu-opened {\n  pointer-events: none;\n}\n\n.slotEditorItem:not(.is-old).draggedNode:hover {\n  background-color: #f4f4f4;\n  background-color: hsla(var(--ui-02-h, 0), var(--ui-02-s, 0%), var(--ui-02-l, 95.68627%), 1);\n}\n\n.slotEditorItem:not(.is-old) > .coachMark {\n  top: 10px;\n  right: -10px;\n}\n\n.slotEditorItem:not(.is-old) .nodrop {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n}\n\n.slotEditorItem:not(.is-old) .nodrop.is-hidden {\n  visibility: hidden;\n}\n\n.slotEditorItem:not(.is-old) .nodrop .svgIcon {\n  height: 16px;\n  width: 16px;\n}\n\n.slotEditorItem:not(.is-old).has-filters .nodrop {\n  -ms-flex-item-align: end;\n      align-self: flex-end;\n}\n\n.slotEditorItem__disambiguatingTooltip {\n  min-width: 240px;\n  text-align: left;\n  padding-bottom: 5px;\n}\n\n.slotEditorItem__disambiguatingTooltipTitle {\n  min-width: 240px;\n  padding-left: 8px;\n  padding-top: 5px;\n}\n\n", ""]);

// exports


/***/ }),
/* 33 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(19),
    now = __webpack_require__(35),
    toNumber = __webpack_require__(38);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(20);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 37 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(39),
    isObject = __webpack_require__(19),
    isSymbol = __webpack_require__(41);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(40);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(42),
    isObjectLike = __webpack_require__(45);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(21),
    getRawTag = __webpack_require__(43),
    objectToString = __webpack_require__(44);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(21);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 45 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(47);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(9)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js??ref--1-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-4!./fieldDropdown.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js??ref--1-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-4!./fieldDropdown.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.slotEditor .dropdownWrapper {\n  width: 100%;\n  min-width: 96px;\n  position: relative;\n}\n\n.slotEditor .dropdownWrapper .dropdown {\n  color: #161616;\n  color: hsla(var(--text-01-h, 0), var(--text-01-s, 0%), var(--text-01-l, 8.62745%), 1);\n  box-shadow: 0 2px 8px 0 #eaeaea;\n  position: absolute;\n  width: 100%;\n}\n\n.slotEditor .ba-common-accordionItem__collapse .ReactCollapse--content {\n  overflow-x: inherit;\n  overflow-y: inherit;\n}\n\n", ""]);

// exports


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StringResources = __webpack_require__(2);

var _StringResources2 = _interopRequireDefault(_StringResources);

var _baUiCarbonToolkit = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * IBM Watson Analytics (C) Copyright IBM Corp. 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


/**
 * The SlotEditorItemFlyout component is responsible for the User Interface for a flyout of a single slot data item
 */
var SlotEditorItemFlyout = function (_Component) {
	_inherits(SlotEditorItemFlyout, _Component);

	function SlotEditorItemFlyout() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, SlotEditorItemFlyout);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SlotEditorItemFlyout.__proto__ || Object.getPrototypeOf(SlotEditorItemFlyout)).call.apply(_ref, [this].concat(args))), _this), _this._onCloseFlyout = function () {
			if (_this.props.onClose) {
				_this.props.onClose();
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(SlotEditorItemFlyout, [{
		key: 'render',
		value: function render() {
			var tooltipLabel = _StringResources2.default.get('slotEditor_slotItem_tooltip');
			var querySubjectItem = this._renderQuerySubjectItem();
			if (querySubjectItem) {
				return _react2.default.createElement(
					_baUiCarbonToolkit.Flyout,
					{
						domNodeToAttachTo: document.body,
						triggerNode: this.props.domNode,
						offset: 30,
						placement: 'topCentred',
						candidatePlacement: ['topCentred'],
						onClose: this._onCloseFlyout
					},
					_react2.default.createElement(
						'div',
						{ className: 'slotEditorItem__disambiguatingTooltipTitle' },
						tooltipLabel
					),
					_react2.default.createElement(
						'div',
						{ className: 'slotEditorItem__disambiguatingTooltip' },
						querySubjectItem
					)
				);
			}
			return null;
		}
	}, {
		key: '_renderQuerySubjectItem',
		value: function _renderQuerySubjectItem() {
			return this.props.dashboardApi.getFeature('DataSources.UI').getColumnSourceTree(this.props.sourceId, this.props.columnId);
		}
	}]);

	return SlotEditorItemFlyout;
}(_react.Component);

SlotEditorItemFlyout.propTypes = {
	domNode: _propTypes2.default.object.isRequired,
	dashboardApi: _propTypes2.default.object.isRequired,
	columnId: _propTypes2.default.string,
	sourceId: _propTypes2.default.string,
	onClose: _propTypes2.default.func
};

exports.default = SlotEditorItemFlyout;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp; /**
                    * Licensed Materials - Property of IBM
                    * IBM Watson Analytics (C) Copyright IBM Corp. 2020
                    * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                    */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _underscore = __webpack_require__(6);

var _underscore2 = _interopRequireDefault(_underscore);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(50);

var _baUiCarbonToolkit = __webpack_require__(5);

var _overflowMenuVertical_ = __webpack_require__(52);

var _overflowMenuVertical_2 = _interopRequireDefault(_overflowMenuVertical_);

var _draggable_ = __webpack_require__(53);

var _draggable_2 = _interopRequireDefault(_draggable_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The common FieldItem component
 */
var FieldItem = (_temp = _class = function (_Component) {
	_inherits(FieldItem, _Component);

	function FieldItem() {
		_classCallCheck(this, FieldItem);

		return _possibleConstructorReturn(this, (FieldItem.__proto__ || Object.getPrototypeOf(FieldItem)).apply(this, arguments));
	}

	_createClass(FieldItem, [{
		key: 'getDOMNode',
		value: function getDOMNode() {
			return this.domNode;
		}
	}, {
		key: '_renderFilterStringAndNumber',
		value: function _renderFilterStringAndNumber(filterInfo) {
			var _ref = filterInfo || {},
			    filterString = _ref.filterString,
			    numberOfFilterItems = _ref.numberOfFilterItems;

			if (filterString) {
				return _react2.default.createElement(
					'div',
					{ className: 'bi-common-field-item__infoLine' },
					_react2.default.createElement(
						'div',
						{ className: 'bi-common-field-item__infoLine__values' },
						_react2.default.createElement(_baUiCarbonToolkit.TruncatedText, { value: filterString })
					),
					numberOfFilterItems ? _react2.default.createElement(
						'div',
						{ className: 'bi-common-field-item__infoLine__badge' },
						numberOfFilterItems
					) : null
				);
			}

			return null;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    fieldName = _props.fieldName,
			    className = _props.className,
			    draggable = _props.draggable,
			    showActionMenu = _props.showActionMenu,
			    onOpenActionMenu = _props.onOpenActionMenu,
			    fieldGraphics = _props.fieldGraphics,
			    filterInfo = _props.filterInfo;

			var forwardedProps = _underscore2.default.omit(this.props, 'className', 'children', 'fieldName', 'draggable', 'showActionMenu', 'onOpenActionMenu', 'fieldGraphics', 'filterInfo');
			var hasFilters = !!(filterInfo && filterInfo.filterString);
			var classNames = (0, _baUiCarbonToolkit.classnames)('bi-common-field-item', {
				'has-filters': hasFilters,
				'is-draggable': draggable
			});

			return _react2.default.createElement(
				'div',
				_extends({
					className: className ? classNames + ' ' + className : classNames,
					'aria-label': fieldName,
					tabIndex: '0',
					ref: function ref(node) {
						_this2.domNode = node;
					}
				}, forwardedProps),
				_react2.default.createElement(
					'div',
					{ className: 'bi-common-field-item__nameLine',
						onMouseEnter: this.props.onMouseEnterCallBack,
						onMouseLeave: this.props.onMouseLeaveCallBack },
					draggable && _react2.default.createElement(
						'div',
						{ className: 'bi-common-field-item__nameLine__draggable' },
						_react2.default.createElement(_baUiCarbonToolkit.SVGIcon, { size: 'small', iconId: _draggable_2.default.id })
					),
					_react2.default.createElement(
						'div',
						{ className: 'bi-common-field-item__nameLine__fieldName' },
						hasFilters ? _react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(_baUiCarbonToolkit.TruncatedText, { location: 'middle', style: { fontWeight: 'bold' }, value: fieldName })
						) : _react2.default.createElement(_baUiCarbonToolkit.TruncatedText, { location: 'middle', style: { fontWeight: 'normal' }, value: fieldName })
					),
					fieldGraphics && _react2.default.createElement(
						'div',
						{ className: 'bi-common-field-item__nameLine__icon' },
						_react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: fieldGraphics } })
					),
					showActionMenu && _react2.default.createElement(
						'div',
						{
							className: 'bi-common-field-item__nameLine__actionMenu',
							tabIndex: 0,
							onKeyPress: function onKeyPress(e) {
								e.stopPropagation();
								onOpenActionMenu(e);
							},
							onClick: function onClick(e) {
								e.stopPropagation();
								onOpenActionMenu(e);
							}
						},
						_react2.default.createElement(_baUiCarbonToolkit.SVGIcon, { size: 'small', iconId: _overflowMenuVertical_2.default.id }),
						_react2.default.createElement('div', { className: 'actionmenu' })
					)
				),
				this._renderFilterStringAndNumber(filterInfo)
			);
		}
	}]);

	return FieldItem;
}(_react.Component), _class.propTypes = {
	className: _propTypes2.default.string,
	fieldName: _propTypes2.default.string.isRequired,
	draggable: _propTypes2.default.bool,
	showActionMenu: _propTypes2.default.bool,
	onOpenActionMenu: _propTypes2.default.func,
	fieldGraphics: _propTypes2.default.node,
	filterInfo: _propTypes2.default.object,
	onMouseEnterCallBack: _propTypes2.default.func,
	onMouseLeaveCallBack: _propTypes2.default.func
}, _class.defaultProps = {
	className: '',
	draggable: true,
	showActionMenu: true,
	onOpenActionMenu: function onOpenActionMenu() {},
	fieldGraphics: null,
	filterInfo: null
}, _temp);
exports.default = FieldItem;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(51);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(9)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js??ref--1-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-4!./FieldItem.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js??ref--1-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-4!./FieldItem.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "/**\n * Licensed Materials - Property of IBM\n * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2020\n * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.\n */\n\n.slotEditor .bi-common-field-item {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column;\n      flex-flow: column;\n  padding-left: 8px;\n  -ms-flex-align: stretch;\n      align-items: stretch;\n  background-color: #f4f4f4;\n  background-color: hsla(var(--ui-02-h, 0), var(--ui-02-s, 0%), var(--ui-02-l, 95.68627%), 1);\n}\n\n.slotEditor .bi-common-field-item.is-draggable {\n  cursor: move;\n}\n\n.slotEditor .bi-common-field-item.is-draggable .bi-common-field-item__nameLine__fieldName {\n  margin-left: 8px;\n}\n\n.slotEditor .bi-common-field-item:hover {\n  background-color: #e5e5e5;\n  background-color: hsla(var(--hover-ui-h, 0), var(--hover-ui-s, 0%), var(--hover-ui-l, 89.80392%), 1);\n}\n\n.slotEditor .bi-common-field-item.has-filters .bi-common-field-item__nameLine {\n  height: 32px;\n}\n\n.slotEditor .bi-common-field-item.has-filters .bi-common-field-item__nameLine__draggable {\n  -ms-flex-item-align: end;\n      align-self: flex-end;\n}\n\n.slotEditor .bi-common-field-item__nameLine {\n  height: 40px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row;\n      flex-flow: row;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 0.875rem;\n}\n\n.slotEditor .bi-common-field-item__nameLine__draggable {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n}\n\n.slotEditor .bi-common-field-item__nameLine__fieldName {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  margin-right: 8px;\n  margin-left: 24px;\n}\n\n.slotEditor .bi-common-field-item__nameLine__icon {\n  margin-right: 8px;\n  margin-left: 8px;\n  width: 16px;\n  height: 16px;\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n}\n\n.slotEditor .bi-common-field-item__nameLine__actionMenu {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  cursor: pointer;\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  padding: 8px;\n}\n\n.slotEditor .bi-common-field-item__infoLine {\n  font-size: 0.75rem;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  height: 24px;\n  margin-right: 6px;\n}\n\n.slotEditor .bi-common-field-item__infoLine__values {\n  margin-left: 24px;\n  margin-right: 8px;\n  -ms-flex: 0 1 auto;\n      flex: 0 1 auto;\n}\n\n.slotEditor .bi-common-field-item__infoLine__badge {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  border-radius: 100%;\n  width: 20px;\n  height: 20px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  background-color: #525252;\n  background-color: hsla(var(--icon-02-h, 0), var(--icon-02-s, 0%), var(--icon-02-l, 32.15686%), 1);\n  color: white;\n  color: hsla(var(--ui-01-h, 0), var(--ui-01-s, 0%), var(--ui-01-l, 100%), 1);\n}\n\n", ""]);

// exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,c){if(true)module.exports=c(__webpack_require__(10));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],c);else{var a=c("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var o in a)("object"==typeof exports?exports:e)[o]=a[o]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([792],{"05e92c9505a6025ba118":function(e,c,a){"use strict";var o=a("9689a9c94ae38b47fa2c"),s=a.n(o),i=a("9ce58a7deea14f49ef01"),n=a.n(i),r=new s.a({id:"overflow-menu--vertical_32_v7",use:"overflow-menu--vertical_32_v7-usage",viewBox:"0 0 32 32",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="overflow-menu--vertical_32_v7"><circle cx="16" cy="8" r="2" /><circle cx="16" cy="16" r="2" /><circle cx="16" cy="24" r="2" /></symbol>'});n.a.add(r);c.a=r},"226a34d55d3eac820fae":function(e,c,a){"use strict";Object.defineProperty(c,"__esModule",{value:!0});var o=a("6873601dfe1d9459c1a9"),s=(a.n(o),a("05e92c9505a6025ba118"));c.default=s.a},"6873601dfe1d9459c1a9":function(c,a){c.exports=e}},["226a34d55d3eac820fae"])});

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){if(true)module.exports=a(__webpack_require__(10));else if("function"==typeof define&&define.amd)define(["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"],a);else{var s=a("object"==typeof exports?require("@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"):e["@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons.js"]);for(var o in s)("object"==typeof exports?exports:e)[o]=s[o]}}("undefined"!=typeof self?self:this,function(e){return webpackJsonPBaGraphics([1326],{"6873601dfe1d9459c1a9":function(a,s){a.exports=e},bd21aca30fb83bdeb1c8:function(e,a,s){"use strict";var o=s("9689a9c94ae38b47fa2c"),c=s.n(o),i=s("9ce58a7deea14f49ef01"),n=s.n(i),t=new c.a({id:"draggable_32_v7",use:"draggable_32_v7-usage",viewBox:"0 0 32 32",content:'<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" id="draggable_32_v7"><path d="M10 6H14V10H10zM18 6H22V10H18zM10 14H14V18H10zM18 14H22V18H18zM10 22H14V26H10zM18 22H22V26H18z" /></symbol>'});n.a.add(t);a.a=t},f8dea1b34095daf0d139:function(e,a,s){"use strict";Object.defineProperty(a,"__esModule",{value:!0});var o=s("6873601dfe1d9459c1a9"),c=(s.n(o),s("bd21aca30fb83bdeb1c8"));a.default=c.a}},["f8dea1b34095daf0d139"])});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(55);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(9)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js??ref--1-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-4!./slotItemPlaceholder.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js??ref--1-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-4!./slotItemPlaceholder.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.slotPlaceholder__hoverIndicator {\n  height: 8px;\n  width: inherit;\n}\n\n.slotPlaceholder__itemPlaceholder {\n  height: 40px;\n  border-style: dashed;\n  border-width: 1px;\n  border-color: #8d8d8d;\n  border-color: hsla(var(--ui-04-h, 0), var(--ui-04-s, 0%), var(--ui-04-l, 55.29412%), 1);\n  margin-bottom: 8px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n\n.slotPlaceholder__itemPlaceholder__actionLabel {\n  color: #a8a8a8;\n  color: hsla(var(--text-03-h, 0), var(--text-03-s, 0%), var(--text-03-l, 65.88235%), 1);\n  font-size: 0.75rem;\n  text-align: center;\n}\n\n.slotPlaceholder.dndHover .slotPlaceholder__itemPlaceholder {\n  border: 2px solid;\n  color: #0f62fe;\n  color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n}\n\n.slotPlaceholder.dndHover .slotPlaceholder__itemPlaceholder__actionLabel {\n  color: #0f62fe;\n  color: hsla(var(--interactive-01-h, 219.16318), var(--interactive-01-s, 99.17012%), var(--interactive-01-l, 52.7451%), 1);\n  text-decoration: underline;\n}\n\n", ""]);

// exports


/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_56__;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _mobxStateTree = __webpack_require__(3);

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
var ACTIVE_PLACEHOLDER_EXISTS_DEFAULT = false;

exports.default = _mobxStateTree.types.model('SlotPlaceholderStateModel', {
	activePlaceholderExists: _mobxStateTree.types.optional(_mobxStateTree.types.boolean, ACTIVE_PLACEHOLDER_EXISTS_DEFAULT)
}).views(function (self) {
	return {
		/**
   * @return {boolean} activePlaceholderExists
   */
		getActivePlaceholderExists: function getActivePlaceholderExists() {
			if ((0, _mobxStateTree.isAlive)(self)) {
				return self.activePlaceholderExists;
			} else {
				return ACTIVE_PLACEHOLDER_EXISTS_DEFAULT;
			}
		}
	};
}).actions(function (self) {
	return {
		setActivePlaceholderExists: function setActivePlaceholderExists(activePlaceholderExists) {
			self.activePlaceholderExists = activePlaceholderExists;
		}
	};
});

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_58__;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * IBM Watson Analytics (C) Copyright IBM Corp. 2018, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
/**
 * The SlotEditorA11YHandler is responsible for handling any slot-editor-specific A11Y handling.
 * Specifically, it handles selection of an item as a drag source and calling back to complete a move on enter.
 */


var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

var _js = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SlotEditorA11YHandler = function () {

	/**
  * Constructor
  */
	function SlotEditorA11YHandler() {
		_classCallCheck(this, SlotEditorA11YHandler);
	}

	/**
  * Handle the case the user hits space on the focused item
  * @param event - the keydown event
  * @param {object} handlers , A JSON object that holds mappings of slot handlers
  * @param [callback] - callback to execute if the key is not space
  */


	_createClass(SlotEditorA11YHandler, [{
		key: 'handleKeyDown',
		value: function handleKeyDown(event, handlers) {
			var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			if (event.key === ' ') {
				//Hitting a space should allow the focus item to be stored (for 'dropping' on enter.)
				this._sourceSelection = handlers.slotDataItemHandler;
				//TODO: addClass/removeClass should be removed when we convert the widget model to mobx
				(0, _jquery2.default)(this.sourceNode).removeClass('selected');
				this.sourceNode = event.target;
				(0, _jquery2.default)(this.sourceNode).addClass('selected');
				event.preventDefault(); // prevent the the browser to scroll page down
			} else {
				this.handleOpenTypeInDropdown(event, callback);
			}
		}

		/**
   * Handle the case the user do delete or paste
   * @param event - the keydown event
   * @param {object} handlers , A JSON object that holds mappings of slot handlers
   */

	}, {
		key: 'handleKeyUp',
		value: function handleKeyUp(event, handlers) {
			if (event.key === 'Delete' || event.key === 'Backspace') {
				if ((0, _jquery2.default)(event.target).hasClass('slotEditorItem')) {
					this.deleteSlotItem(handlers.slotDataItemHandler);
					event.preventDefault();
				}
			} else if (_js.A11YUtils.isPaste(event)) {
				this.slotHandleKeyUp(event, handlers.slotDataItemHandler);
				event.preventDefault();
			}
		}

		/**
   * Handle key down event specifically for local filter item
   * @param event - the keydown event
   * @param filterItemActionHandler - filterItemActionHandler
   * @param options
   * @param options.metaDataColumn - metaDataColumn
   * @param options.filterId - filterId
   */

	}, {
		key: 'handleKeyUpForFilterItem',
		value: function handleKeyUpForFilterItem(event, filterItemActionHandler, options) {
			if (event.key === 'Delete' || event.key === 'Backspace') {
				if ((0, _jquery2.default)(event.target).hasClass('slotEditorItem')) {
					this._deleteFilterItem(filterItemActionHandler, options);
					event.preventDefault();
				}
			}
		}

		/**
   * Handle 'enter' key event if no selection is made already
   * @param {} event - the keydown event 
   * @param {*} expandDropdown - callback to execute 
   */

	}, {
		key: 'handleOpenTypeInDropdown',
		value: function handleOpenTypeInDropdown(event, expandDropdown) {
			if (!this._sourceSelection && event.key === 'Enter') {
				expandDropdown();
			}
		}

		/**
   * Complete the action by calling the onEnter callback.
   * @param event - the keypress event
   * @param cbOnEnter - a callback function which should complete the event when a user hits enter.
   * @param options - pass any options on to the callback function as an argument (in the form the callback expects)
   */

	}, {
		key: 'handleKeyPress',
		value: function handleKeyPress(event, cbOnEnter, options) {
			if (this._sourceSelection && event.key === 'Enter') {
				//TODO: addClass/removeClass should be removed when we convert the widget model to mobx
				(0, _jquery2.default)(this.sourceNode).removeClass('selected');
				cbOnEnter(this._sourceSelection, options);
				this._sourceSelection = null;
				event.preventDefault();
			}
		}

		/**
   * Handles adding data item from tree and Ctrl + V to slot area
   * @param event
   * @param slotDataItemHandler
   */

	}, {
		key: 'slotHandleKeyUp',
		value: function slotHandleKeyUp(event, slotDataItemHandler) {
			// ctrl + V
			if (_js.A11YUtils.isPaste(event)) {
				var addAfter = !(event && event.target && event.target.classList.contains('slotEditorItem'));
				slotDataItemHandler.onDropA11Y(addAfter);
			}
		}

		/**
   * Handles adding data item from tree and Ctrl + V to context filters
   * @param event
   * @param node
   * @param dropSlotItemHandler
   * @param filterItemActionHandler
   */

	}, {
		key: 'filterHeaderHandleKeyUp',
		value: function filterHeaderHandleKeyUp(event, node, dropFilterItemHandler, filterItemActionHandler) {
			// ctrl + V
			if (_js.A11YUtils.isPaste(event)) {
				filterItemActionHandler.onDropA11Y(node);
			}
		}
	}, {
		key: 'deleteSlotItem',
		value: function deleteSlotItem(slotDataItemHandler) {
			return slotDataItemHandler.getActions().then(function (actions) {
				var deleteAction = actions.find(function (action) {
					return action && action.name === 'delete';
				});
				deleteAction && deleteAction.actions.apply();
			});
		}
	}, {
		key: '_deleteFilterItem',
		value: function _deleteFilterItem(filterItemActionHandler, options) {
			return filterItemActionHandler.getActions(options.metadataColumn, options.filterId).then(function (actions) {
				var deleteAction = actions.find(function (action) {
					return action.deleteLocalFilter !== undefined;
				});
				if (deleteAction) {
					deleteAction.deleteLocalFilter();
				}
			});
		}
	}]);

	return SlotEditorA11YHandler;
}();

exports.default = SlotEditorA11YHandler;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A11YUtils = exports.A11YDirection = exports.A11YCollections = undefined;

var _Collections = __webpack_require__(61);

var _Collections2 = _interopRequireDefault(_Collections);

var _Direction = __webpack_require__(62);

var _Direction2 = _interopRequireDefault(_Direction);

var _Utils = __webpack_require__(63);

var _Utils2 = _interopRequireDefault(_Utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.A11YCollections = _Collections2.default;
exports.A11YDirection = _Direction2.default;
exports.A11YUtils = _Utils2.default; /*
                                      *+------------------------------------------------------------------------+
                                      *| Licensed Materials - Property of IBM
                                      *| IBM Cognos Products: Explore
                                      *| (C) Copyright IBM Corp. 2018
                                      *|
                                      *| US Government Users Restricted Rights - Use, duplication or disclosure
                                      *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                      *+------------------------------------------------------------------------+
                                      */

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(6);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(4);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var A11YCollections = function () {
	function A11YCollections(options) {
		_classCallCheck(this, A11YCollections);

		if (Array.isArray(options.direction)) {
			this.direction = options.direction;
		} else {
			this.direction = [options.direction];
		}

		this.adapters = {
			elements: options.handlers.elements,
			container: options.handlers.container
		};
	}

	_createClass(A11YCollections, [{
		key: 'onKeyDown',
		value: function onKeyDown(event) {
			for (var i = 0; i < this.direction.length; i++) {
				var direction = this.direction[i];

				switch (event.key) {
					case direction.previous:
						this._handleFocusPrevious(event);
						return;
					case direction.next:
						this._handleFocusNext(event);
						return;
				}
			}
		}
	}, {
		key: '_handleFocusPrevious',
		value: function _handleFocusPrevious(event) {
			if (this._getContainer(event.target).length > 0) {
				this._cycleFocus(event, -1);

				event.preventDefault();
			}
		}
	}, {
		key: '_handleFocusNext',
		value: function _handleFocusNext(event) {
			if (this._getContainer(event.target).length > 0) {
				this._cycleFocus(event, 1);

				event.preventDefault();
			}
		}

		/// Adapters

	}, {
		key: '_getElements',
		value: function _getElements(element) {
			if (_underscore2.default.isFunction(this.adapters.elements)) {
				return (0, _jquery2.default)(this.adapters.elements(element));
			}
			return (0, _jquery2.default)(this.adapters.elements);
		}
	}, {
		key: '_getContainer',
		value: function _getContainer(element) {
			if (this.adapters.container) {
				return (0, _jquery2.default)(this.adapters.container(element));
			}
			return (0, _jquery2.default)(element);
		}

		/// Private

	}, {
		key: '_cycleFocus',
		value: function _cycleFocus(event, increment) {
			var index = this._getContainer(event.target).index();

			this._focus(this._getElements(event.target), index + increment);
		}
	}, {
		key: '_focus',
		value: function _focus(items, index) {
			if (index >= items.length) {
				// Loop back to the first element.
				index = 0;
			}

			items.eq(index).focus();
		}
	}]);

	return A11YCollections;
}();

exports.default = A11YCollections;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

var Direction = {
  UP_DOWN: {
    previous: 'ArrowUp',
    next: 'ArrowDown'
  },
  LEFT_RIGHT: {
    previous: 'ArrowLeft',
    next: 'ArrowRight'
  }
};

exports.default = Direction;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
/**
 * Check if the event is Ctrl + V
 * @param {object} event 
 */
var A11YUtils = function () {
  function A11YUtils() {
    _classCallCheck(this, A11YUtils);
  }

  _createClass(A11YUtils, null, [{
    key: "isPaste",
    value: function isPaste(event) {
      return event.keyCode === 86 && (event.ctrlKey || event.metaKey);
    }
  }]);

  return A11YUtils;
}();

exports.default = A11YUtils;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _baUiCarbonToolkit = __webpack_require__(5);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(65);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| IBM Cognos Products: Dashboard
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| (C) Copyright IBM Corp. 2019, 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var SlotEditorEmptyState = function (_Component) {
	_inherits(SlotEditorEmptyState, _Component);

	function SlotEditorEmptyState(props) {
		_classCallCheck(this, SlotEditorEmptyState);

		return _possibleConstructorReturn(this, (SlotEditorEmptyState.__proto__ || Object.getPrototypeOf(SlotEditorEmptyState)).call(this, props));
	}

	_createClass(SlotEditorEmptyState, [{
		key: 'render',
		value: function render() {
			var emptyState = this._renderEmptyState();
			var title = this.renderTitle();
			var description = this.renderDescription();
			return _react2.default.createElement(
				'div',
				{ className: 'slotEditorEmpty' },
				_react2.default.createElement(
					'div',
					{ className: 'slotEditorEmpty__container' },
					emptyState,
					title,
					description
				)
			);
		}
	}, {
		key: '_renderEmptyState',
		value: function _renderEmptyState() {
			return (
				// This surrounding div is temporary needed to hide the SVG until https://jsw.ibm.com/browse/BAUICOMMON-691 delivers an updated SVG
				_react2.default.createElement(
					'div',
					{ 'data-html2canvas-ignore': true },
					_react2.default.createElement(_baUiCarbonToolkit.EmptyState, {
						type: this.props.type,
						size: 'large' })
				)
			);
		}
	}, {
		key: 'renderTitle',
		value: function renderTitle() {
			if (this.props.title) {
				return _react2.default.createElement(_baUiCarbonToolkit.Label, { label: this.props.title, className: 'slotEditorEmpty__title' });
			}
			return null;
		}
	}, {
		key: 'renderDescription',
		value: function renderDescription() {
			if (this.props.description) {
				var description = this.props.description;
				return _react2.default.createElement(_baUiCarbonToolkit.Label, { label: description, className: 'slotEditorEmpty__description' });
			}
			return null;
		}
	}]);

	return SlotEditorEmptyState;
}(_react.Component);

SlotEditorEmptyState.propTypes = {
	title: _propTypes2.default.string,
	description: _propTypes2.default.string,
	iconId: _propTypes2.default.string,
	alignment: _propTypes2.default.string,
	type: _propTypes2.default.string
};

SlotEditorEmptyState.defaultProps = {
	title: null,
	iconId: null,
	description: null,
	alignment: null,
	type: 'default'
};

exports.default = SlotEditorEmptyState;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(66);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(9)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js??ref--1-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-4!./slotEditorEmptyState.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js??ref--1-1!../../node_modules/postcss-loader/index.js??ref--1-2!../../node_modules/resolve-url-loader/index.js!../../node_modules/sass-loader/lib/loader.js??ref--1-4!./slotEditorEmptyState.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2019, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n.slotEditorEmpty {\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n.slotEditorEmpty__container {\n  margin: auto;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding-left: 1rem;\n}\n\n.slotEditorEmpty__container .slotEditorEmpty__title {\n  padding: 1.5rem 0 0.5rem 0.5rem;\n  font-size: 1.25rem;\n  font-weight: 400;\n  line-height: 1.75rem;\n  letter-spacing: 0;\n  color: #525252;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 32.15686%), 1);\n}\n\n.slotEditorEmpty__container .slotEditorEmpty__description {\n  padding-left: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.25rem;\n  letter-spacing: 0.16px;\n  color: #525252;\n  color: hsla(var(--text-02-h, 0), var(--text-02-s, 0%), var(--text-02-l, 32.15686%), 1);\n}\n\n", ""]);

// exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| Licensed Materials - Property of IBM
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| IBM Cognos Products: Explore
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| (C) Copyright IBM Corp. 2020
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *|
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| US Government Users Restricted Rights - Use, duplication or disclosure
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *| restricted by GSA ADP Schedule Contract with IBM Corp.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *+------------------------------------------------------------------------+
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _utils = __webpack_require__(7);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollableDragHandler = function () {
	function ScrollableDragHandler(options) {
		_classCallCheck(this, ScrollableDragHandler);

		this.accepts = function () {
			return false;
		};

		this.scrollableContainer = options.scrollableContainer;
		this.priority = function () {
			return 10;
		};
		this.dndManager = options.dndManager;
		this.receiveEventsWhenNotAccepting = true; // this is needed by dndManager
	}

	_createClass(ScrollableDragHandler, [{
		key: 'onDragMove',
		value: function onDragMove(dragObject, dropTarget, event) {
			var _this = this;

			(0, _utils.handleScroll)(event, this.scrollableContainer, function () {
				return _this.dndManager && _this.dndManager.reassessContainer(_this.scrollableContainer);
			});
		}
	}]);

	return ScrollableDragHandler;
}();

exports.default = ScrollableDragHandler;

/***/ })
/******/ ])});;


// WEBPACK FOOTER //
// SlotEditorDOM.js